<ng-container *ngIf="!!featureTags && !featureTags['sf_nos_to_unit']">
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" *ngIf="data['msg'] === 'Credit card Not Found'">
        <h1 mat-dialog-title>You don't have any active Payment Option!</h1>
        <div class="text-end">
            <button mat-mini-fab color="warn" (click)="closeDialog()">
            <i class="material-icons" data-icon="close"></i>
          </button>
        </div>
    </div>
    <!-- <h1 mat-dialog-title *ngIf = "data['msg'] === 'Credit card Not Found'"> You don't have any active Payment Option!</h1> -->
    <div mat-dialog-content *ngIf="data['msg'] === 'Credit card Not Found'">
        <p>We have introduced an automatic billing system to our website and it requires the end customer to input the credit card information safely in a secure environment. Please add your credit card so that you can save this order. </p>
    </div>
    <div mat-dialog-actions fxLayoutAlign="end" fxLayout="row" class="mb-5" *ngIf="data['msg'] === 'Credit card Not Found'">
        <button mat-raised-button (click)="goToPayment()" class="proceed-payment-btn">
        Proceed to Payment Options
      </button>
        <!-- <button mat-button matDialogClose ="cancel">Close</button> -->
    </div>
    
    <h1 mat-dialog-title *ngIf="data['msg'] === 'delete credit card'"> Delete Credit Card</h1>
    <div mat-dialog-content *ngIf="data['msg'] === 'delete credit card'">
        <p>Are you sure you want to delete this Card? </p>
    </div>
    <div mat-dialog-actions *ngIf="data['msg'] === 'delete credit card'" fxLayoutAlign ="end">
        <button mat-button matDialogClose="delete" color="warn">Delete</button>
        <button mat-button matDialogClose="cancel">Cancel</button>
    </div>
    
    
    <h1 mat-dialog-title *ngIf="data['msg'] === 'cut off time error'">
        <span *ngIf="selectedDeliveryCalendar !== null && selectedDeliveryCalendar['create_order'] === true">Order cutoff time</span>
        <span *ngIf="selectedDeliveryCalendar !== null &&  selectedDeliveryCalendar['create_order'] === false"> Over and done</span>
    </h1>
    <div mat-dialog-content *ngIf="data['msg'] === 'cut off time error'">
        <p>{{data['display']}} </p>
    </div>
    <div mat-dialog-actions *ngIf="data['msg'] === 'cut off time error'" fxLayoutAlign ="end"> 
        <button mat-button *ngIf="router.url !== '/account/orders'" matDialogClose="close" 
            (click)="redirectTo('/account/orders', true)" color="warn">Go back to My Orders</button>
        <button mat-button *ngIf="router.url === '/account/orders'" matDialogClose="close" color="warn">Close</button>
    </div>
    
    <h1 mat-dialog-title *ngIf="data['msg'] === 'failed to add'">
        Failed to Add Cart
    </h1>
    <div mat-dialog-content *ngIf="data['msg'] === 'failed to add'">
        <p>{{data['display']}} </p>
    </div>
    <div mat-dialog-actions *ngIf="data['msg'] === 'failed to add'" fxLayoutAlign ="end"> 
        <button mat-button matDialogClose="close" color="warn">Close</button>    
    </div>
    
    <h1 mat-dialog-title *ngIf="data['msg'] === 'order start date error'">
        <span *ngIf="selectedDeliveryCalendar !== null && selectedDeliveryCalendar['create_order'] === true">Order Availability Notice</span>
    </h1>
    <div mat-dialog-content *ngIf="data['msg'] === 'order start date error'">
        <p>{{data['display']}} </p>
    </div>
    <div mat-dialog-actions *ngIf="data['msg'] === 'order start date error'" fxLayoutAlign ="end"> 
        <button mat-button *ngIf="router.url !== '/account/orders'" matDialogClose="close" 
            (click)="redirectTo('/account/orders', true)" color="warn">Go back to My Orders</button>
        <button mat-button *ngIf="router.url === '/account/orders'" matDialogClose="close" color="warn">Close</button>
    </div>
    
    <!-- Delivery Preference Dialog Start -->
    <div class="close-btn-outer" *ngIf="data['msg'] === 'Delivery Preference'">
        <button mat-mini-fab matDialogClose="close" color="warn"><i class="material-icons" data-icon="close"></i></button>
    </div>
    <div mat-dialog-content class="DeliveryPreferenceDialog" *ngIf="data['msg'] === 'Delivery Preference'" fxLayoutAlign ="end">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex="100">
            <mat-card class="p-0">
                <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
                    <mat-card-title class="m-0"><h3>{{data['deliveryPreference']}} Address</h3></mat-card-title>
                </mat-card-header>
                <div class="divider"></div>
                <mat-card-content class="p-2 text-muted account-card-content">
                    <p *ngIf="data['pickupLocName']"><b>Pickup Location - {{data['pickupLocName']}}</b></p>
                    <p *ngIf="data['formatted_address']">{{data['formatted_address']}}</p>
                    <p *ngIf="data['deliveryDays']"><strong>Delivery Days : </strong><span  [ngStyle]="{'color': '#C62828'}"> {{data['deliveryDays']}}</span></p>
                    <p *ngIf="data['locationNotes']"><strong>Notes : </strong><span  [ngStyle]="{'color': '#C62828'}"> {{data['locationNotes']}}</span></p>
                </mat-card-content>
            </mat-card>
        </div>   
    </div>
    <div fxLayout="row wrap"  *ngIf="data['msg'] === 'Delivery Preference'"  fxLayoutAlign="space-between center" class="mt-1 dpchangeBtn">
        <button (click)="closeDialog()" mat-raised-button color="primary" routerLink="/account/addresses">Change</button>
    </div>
    <!-- Delivery Preference Dialog End -->
    
    <!-- Coupon Apply or Edit Dialog Start -->
    
    <div class="CouponsDialogDiv" *ngIf="data['msg'] === 'Coupons Apply'">
        <div fxLayout="row">
            <h2 mat-dialog-title fxFlex class="popup-title">APPLY COUPON</h2>
            <div fxFlex class="text-end">
                <button mat-mini-fab color="warn" (click)="closeDialog()"><i class="material-icons" data-icon="close"></i>
                </button>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div mat-dialog-content class="CouponsDialog">
            <div fxLayout="row" class = "couponDiv">
                <div fxFlex = "70" class="couponInputDiv" fxLayoutAlign="space-between center">
                    <input matInput [(ngModel)]="couponCode" placeholder="Enter coupon code">
                </div>
                <div fxLayoutAlign="end" fxFlex = "30">
                    <button mat-button class = "couponbtn btn-clr" (click)="applyCoupon(data['coupons'])" 
                    [disabled]="isLoadingCouponBtn" [ngClass]="{'routeworx-spinner spinner-style3': isLoadingCouponBtn}" id="applyCoupon">
                        <span>APPLY</span>
                    </button> 
                </div>
            </div>
            <mat-error class="{{couponError['class']}}" *ngIf="couponError['message']">
                {{couponError['message']}}
            </mat-error>
            <mat-divider class="divider"></mat-divider>
            <div class="p-1">
                <div fxLayout="row" class="appliedCoupons" *ngFor="let coupon of data['coupons']">
                   <div class="appliedCouponsRow p-1" fxLayoutAlign="space-between center">
                        <h5 *ngIf="coupon['extended_price'] && coupon['extended_price']>0">
                            <div class="couponCodeDiv">
                                <!-- <mat-checkbox class="couponCheckBox" matInput [id]="'couponCheckbox_'+ coupon['coupon_code']" [(ngModel)]="isCheckedCoupon[coupon['coupon_code']]" color="primary">
                                </mat-checkbox>&nbsp; -->
                                <!-- <input type="checkbox" class="couponCheckBox" id="couponCheckbox_{{coupon['coupon_code']}}" name="couponCheckbox_{{coupon['coupon_code']}}" checked> -->
                                <!-- <mat-icon class="couponsDiscountIcon" aria-hidden="false">discount</mat-icon>&nbsp; -->
                                <span class="couponCodeSpn">{{coupon['coupon_code']}}</span>
                                <span class="couponBenefit"> Save {{data['currency']}}{{coupon['extended_price'] | number: '1.2-2'}}</span>
                            </div>
                            <div class="couponInfo">
                                <br><span class="couponDesc">{{coupon['coupon_desc']}}</span>
                            </div>
                        
                        </h5>
                    <mat-icon class="couponsDeleteIcon" (click)="deleteCoupon(coupon)" aria-hidden="false" id="deleteCoupon">delete_outline</mat-icon>
                   </div>
                    <mat-divider class="divider"></mat-divider>
                   <!-- <span>&nbsp;&nbsp;</span>
                    <h5 class="couponsPrice" *ngIf="coupon['extended_price'] && coupon['extended_price']>0">{{data['currency']}}<span>{{coupon['extended_price'] | number: '1.2-2' }}</span></h5> -->
                </div>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center start">
                <div class="lbl">
                    <p class="couponsTotalAmount" fxShow.lt-md="true">Maximum savings :&nbsp;</p>
                </div>
                <p class="couponsTotalAmount" fxShow.lt-md="true">
                    <span > {{data['currency']}}{{couponsTotalAmount  | number: '1.2-2'}}</span>
                </p>
            </div>
            
            <!-- <div class="product-action">
                <button *ngIf="data['coupons']" mat-raised-button (click)="applyCoupon(data['coupons'])" class="btn-add">
                    APPLY
                </button>
            </div> -->
        </div>
    </div>
    <!-- Coupon Coupon Apply or Edit Dialog End -->
    
    <!-- Coupon Details Dialog Start -->
    <div class="close-btn-outer" *ngIf="data['msg'] === 'Coupon Details'">
        <button mat-mini-fab matDialogClose="close" color="warn"><i class="material-icons" data-icon="close"></i></button>
    </div>
    <div mat-dialog-content class="DeliveryPreferenceDialog" *ngIf="data['msg'] === 'Coupon Details' && data['coupons']" fxLayoutAlign ="end">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex="100">
            <mat-card class="p-0">
                <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
                    <mat-card-title class="m-0"><h3>Applied Coupons</h3></mat-card-title>
                </mat-card-header>
                <div class="divider"></div>
                <mat-card-content class="text-muted couponList" *ngFor="let coupon of data['coupons']">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <h5 *ngIf="coupon['extended_price'] && coupon['extended_price']>0"><mat-icon class="couponsPrice" aria-hidden="false">discount</mat-icon>&nbsp;{{coupon['coupon_code']}}</h5>
                        <span>&nbsp;&nbsp;</span>
                        <h5 class="couponsPrice" *ngIf="coupon['extended_price'] && coupon['extended_price']>0">{{data['coupons']['currency']}}<span>{{coupon['extended_price'] | number: '1.2-2' }}</span></h5>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>   
    </div>
    <!-- Coupon Details Dialog End -->
    
    <!-- Tax Details Dialog Start -->
    <div class="close-btn-outer" *ngIf="data['msg'] === 'Tax Details'">
        <button mat-mini-fab matDialogClose="close" color="warn"><i class="material-icons" data-icon="close"></i></button>
    </div>
    <div mat-dialog-content class="DeliveryPreferenceDialog" *ngIf="data['msg'] === 'Tax Details' && data['taxesInfo']" fxLayoutAlign ="end">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex="100">
            <mat-card class="p-0 taxDetailsDiv">
                <mat-card-header fxLayout="column" class="p-1 account-card-title" fxLayoutAlign="space-between center">
                    <mat-card-title class="m-0"><h3>Tax Details</h3></mat-card-title>
                </mat-card-header>
                <div class="divider"></div>
                <div *ngFor="let tax of data['taxesInfo']">
                    <mat-card-content class="text-muted couponList" *ngIf="tax['product_tax'] && tax['product_tax'].length>0">
                            <div fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let ptax of tax['product_tax']">
                                <h5 *ngIf="ptax['tax_name'] && ptax['ext_tax']>0">{{ptax['tax_name']}}&nbsp;({{ptax['tax_percentage'] ? ptax['tax_percentage'] : ptax['tax_rate_percentage'] }}%)</h5>
                                <span>&nbsp;&nbsp;</span>
                                <h5 *ngIf="ptax['tax_name'] && ptax['ext_tax']>0">{{data['currency']}}<span>{{ptax['ext_tax'] | number: '1.2-2' }}</span></h5>
                            </div>
                    </mat-card-content>
                </div>
            </mat-card>
        </div>   
    </div>
    <!-- Tax Details Dialog End -->
    
    <!-- Edit Subscription Dialog Start -->
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" *ngIf="data['msg'] === 'edit subscription'">
        <h1 mat-dialog-title>Edit Recurring Items</h1>
        <div class="text-end">
            <button mat-mini-fab color="warn" (click)="closeDialog()">
                <i class="material-icons" data-icon="close"></i>
            </button>
        </div>
    </div>
    <div mat-dialog-content *ngIf="data['msg'] === 'edit subscription'">
        <div class="product" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
            <div class="product-img">
                <img src="data:," [imgName]="data['data']['product']['product_image1']" imgType="products" 
                imgSize="xs" imagePreload alt = "{{data['data']['description']}}" />
            </div>
            <div class="product-content" fxLayout="column">
                <h3 class="title">{{data['data']['description']}}</h3>
                <div fxLayout="row"  fxLayoutAlign=" start">
                    <p class="price">{{data['data']['currency']}}
                        {{(data['data']['product']['retail_price'] * data['data']['quantity'] | number: '1.2-4' | replacecomma) | number: '1.2-2'}}
                    </p>
                <p class=" text-muted pd-l-5" *ngIf = "!!data['data']['product'].compare_price"><span class = "old-price">{{data['data']['currency']}}
                        <span *ngIf = "!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">{{((data['data']['product']['compare_price'] *  quantityControl.value * data['data']['product']['sell_in_conv_rate']) | number: '1.2-4' | replacecomma)  | number : '1.2-2'}}  </span>
                        <span *ngIf = "(!!data['data']['product']['sell_in_uof'] === false || (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos') )">{{((data['data']['product'].compare_price  *  quantityControl.value) | number: '1.2-4' | replacecomma) | number : '1.2-2'}}  </span>
                </span> Saved ({{data['data'].savepercentage}}%)</p>                               
                </div>
               
            </div>
        </div>
        <div class="prod_status" fxLayout="row"  fxLayoutGap="20px"> 
            <div class="btl product_bottle" *ngIf="data['data']['product']['bottle_charge']">
                <span  fxLarout="row" fxLayoutAlign="center center">
                    <img src = "assets/images/others/bottle-icon.png" alt = "Bottle present"> <span>Glass bottle</span>
                </span>
            </div>
            <div class="btl warn product_stock mr-0" *ngIf="data['data']['product_status'] || data['data']['product']['is_delete']">
                <span  fxLarout="row" fxLayoutAlign="center center">
                    <mat-icon>clear</mat-icon>Sold Out
                </span>
            </div>
            <div class = "lbs_product" *ngIf="data['data']['product']['cb_unit_of_measurement']['acronym'] === 'lbs'">
                <span  fxLarout="row" 
                fxLayoutAlign="center center">
                  <img src="assets/images/lbs.png" alt ="Lbs product"> 
                </span>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <!-- <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px"> -->
            <!-- <div fxFlex="35" class="product-dates">
                <p class="delivery-day">DeliveryDay</p>
                <p class="day-name">{{data['data']['deliveryDay'] | titlecase}}</p>
            </div> -->
            <!--<div fxFlex="35" class="product-dates" *ngIf="!data['data']['cart']">
                <p class="last-delivery">Last <br fxShow="false" fxShow.lt-sm>Delivered:</p>
                <p class="last-date" *ngIf="data['data']['last_recurring_date'] === false">NIL</p>
                <p class="last-date" *ngIf="data['data']['last_recurring_date'] !== false">
                    {{data['data']['last_recurring_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}
                </p>
            </div> -->
            <!-- <div fxFlex="35" class="product-dates" *ngIf="!data['data']['skipped_delivery'] && !data['data']['cart']">
                <p class="next-delivery">
                    Next Delivery:</p>
                <p class="next-date">
                    {{data['data']['recurring_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}
                </p>
            </div> -->
        <!-- </div> -->
        <!-- <mat-divider class="divider"></mat-divider> -->
        <p><b>Change Qty (Subscribed for <span *ngIf = "data['data']['recurring_qty']">{{data['data']['recurring_qty']}}</span><span *ngIf = "!data['data']['recurring_qty']">{{data['data']['quantity']}}</span>
            <span *ngIf ="data['data']['product']['cb_unit_of_measurement']['name'] === 'Weight in 1lbs'">lbs</span>)</b></p>
        <div class="product-form" fxLayout="column">
            <ng-container *ngIf="!!featureTags && !featureTags['sf_average_size_message']">
                <span  fxFlex="50" *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'" class = "ft-12">(Average size of 1 qty is {{data['data']['product']['sell_in_conv_rate']}} lbs)</span>
            </ng-container>
            <ng-container *ngIf="!!featureTags && featureTags['sf_average_size_message']">
                <span  fxFlex="50" *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'" class = "ft-12">(Average size is {{data['data']['product']['sell_in_conv_rate']}} lbs)</span>
            </ng-container>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
                <div fxLayout="column"  fxFlex="50">
                    <mat-form-field appearance="outline" 
                        class="product-quantity customize-mat-form-field reduce-mat-form-field-height">
                        <!-- <mat-label>Quantity</mat-label> -->
                        <mat-select [formControl]="quantityControl"
                        [disabled]="data['data']['turnDisabled'] || (data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" (openedChange)="onOpenedChange($event)">
                            <mat-option [value]="data['data']['quantity']" >{{data['data']['quantity']}}
                                <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                    <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                    <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">lbs</span>
                                </span>
                            </mat-option>
                            <mat-option *ngFor="let quantity of displayedQuantities" [value]="quantity">
                                {{quantity}} 
                                <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                    <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                    <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">nos</span>
                                </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                
                <div fxFlex="50" fxLayoutGap="5px" fxLayoutAlign = "center">
                    <button mat-raised-button fxFlex="50"  *ngIf="data['data']['turnDisabled'] === true"
                    [disabled]="(data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                    (click)="enableProduct(data['data'], quantityControl)">Edit</button>
                    <div class="button-container" >
                        <div class="spinner-container" *ngIf="data['data']['qtyLoad'] && (!data['data']['saleId'] && !data['data']['cart']) || (data['data']['cart'] && (data['data']['cart']['check'] === 'recurring' || data['data']['cart']['check'] === 'cart'))">
                        <mat-spinner diameter="24"></mat-spinner>
                        </div>
                        <button mat-raised-button fxFlex="50" 
                        *ngIf="data['data']['turnDisabled'] === false && (!data['data']['saleId'] && !data['data']['cart']) || (data['data']['cart'] && (data['data']['cart']['check'] === 'recurring' || data['data']['cart']['check'] === 'cart'))" [disabled]="data['data']['qtyLoad'] || (data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                        (click)="recurringQuantityUpdate(data['data'], quantityControl)">Update</button>
                    </div>
                    <div class="button-container" >
                        <div class="spinner-container" *ngIf="data['data']['qtyLoad'] && (data['data']['saleId'] || (data['data']['cart'] && data['data']['cart']['check'] === 'sale'))">
                        <mat-spinner diameter="24"></mat-spinner>
                        </div>
                        <button mat-raised-button fxFlex="50" 
                        *ngIf="data['data']['turnDisabled'] === false && (data['data']['saleId'] || (data['data']['cart'] && data['data']['cart']['check'] === 'sale'))"  [disabled]="data['data']['qtyLoad'] || (data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                        (click)="orderQuantityUpdate(data['data'], quantityControl)">Update</button>
                    </div>
                    <button mat-raised-button fxFlex="50" 
                    *ngIf="data['data']['turnDisabled'] === false"
                    (click)="cancel(data['data'])">Cancel</button>
                </div>
               
            </div>
            <div class="mt-7px" *ngIf="data['data']['turnDisabled'] === false">
                <mat-radio-group aria-label="Select an option" class="ft-sz" 
                [disabled]="(data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                (change)="handleChange($event)" fxLayoutGap="10px">
                    <mat-radio-button [value]="option['value']" class="color" [checked]="option['checked']" 
                        *ngFor="let option of radioButtonOptions">{{option['display']}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <mat-divider class="divider"></mat-divider>
            <p><b>Edit Frequency</b></p>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
                <mat-form-field fxFlex="50" appearance="outline" 
                    class="w-100 product-frequency customize-mat-form-field reduce-mat-form-field-height">
                    <mat-select [formControl]="frequencyControl" [disabled]="data['data']['turnFreqDisabled'] === true || (data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" >
                        <mat-option *ngFor="let frequency of cartFrequencies" [value]="frequency">
                            {{frequency}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div fxFlex="50" fxLayoutGap="5px" fxLayoutAlign = "center">
                    <button mat-raised-button fxFlex="50"  *ngIf="data['data']['turnFreqDisabled'] === true"
                    [disabled]="(data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                    (click)="enableProductFrequency(data['data'], quantityControl)">Edit</button>
                    <div class="button-container" >
                        <div class="spinner-container" *ngIf="data['data']['freqLoad']">
                        <mat-spinner diameter="24"></mat-spinner>
                        </div>
                        <button mat-raised-button fxFlex="50" *ngIf="data['data']['turnFreqDisabled'] === false" [disabled] ="data['data']['freqLoad']"
                        (click)="recurringUpdate($event, data['data'], 'frequency')">Update</button>
                    </div>
                    <button mat-raised-button fxFlex="50" 
                    *ngIf="data['data']['turnFreqDisabled'] === false"
                    (click)="cancelFrequency(data['data'])">Cancel</button>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="10px" *ngIf="showStartDate">
            <div>
                Start Date: {{data['data']['recurring_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}
            </div>
            <div fxLayout="row" fxLayoutGap="10px" *ngIf="this.url === '/edit-order' || this.url === '/account/recurring'">
                <mat-icon>calendar_today</mat-icon>
                <ng-container *ngIf="!!featureTags && !featureTags['recurring_start_date_not_considered_in_sf'];else disableChangeDate">
                    <div (click)="picker.open()" class="start-date" >Change Start Date</div>
                </ng-container>
                <ng-template #disableChangeDate>
                    <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_wrong_holiday_recurring_dates']">
                        <div class="start-date" [ngClass]="{ 'isDisabledDatepicker': isDisabledDatepicker }" (click)="!isDisabledDatepicker && fetchDatesAndOpenDatepicker(picker, data['data']['id'])"> Change Start Date</div>
                    </ng-container>
                    <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_wrong_holiday_recurring_dates']">
                        <div class="start-date" [ngClass]="{ 'isDisabledDatepicker': isDisabledDatepicker }" (click)="!isDisabledDatepicker && picker.open()"> Change Start Date </div>
                    </ng-container>
                </ng-template>
            </div>
            <mat-form-field class="example-full-width" fxHide>
                <input matInput [matDatepicker]="picker" (dateInput)="addEvent('input', $event)" (dateChange)="addEvent('change', $event)" [matDatepickerFilter]="deliveryDayFilter" [min]="minDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker touchUi #picker></mat-datepicker>
            </mat-form-field>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div class="subscription-cancel" fxLayout="column" fxLayoutGap="10px">
            <!-- <button mat-raised-button *ngIf = "data['data']['cart'] && data['data']['cart']['delivery_date'] === ''" (click) = "addToThisWeek(data)">Add To This  Week </button> -->
            <button mat-raised-button (click)="stopRecurring(data['data'])" color="primary">Stop this item</button>
        </div>
        <div class="mt-2" *ngIf="router.url !== '/account/recurring'">
            <a [routerLink]="['/account/recurring']" (click)="closeDialog()" matTooltip="View all Recurring Products">View all Recurring Items</a>
        </div>
    </div>
    <!-- End -->
    
    <!-- Edit Subscription Form Products Strat -->
    <div fxLayout="column" *ngIf="data['msg'] === 'edit subscription from products'">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px">
            <h1 mat-dialog-title class="popup-title">Already in Recurring </h1>
            <div class="text-end">
                <button mat-mini-fab color="warn" (click)="closeDialog()">
                    <i class="material-icons" data-icon="close"></i>
                </button>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div mat-dialog-content>
            <div class="product" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="product-img">
                    <img src="data:," [imgName]="data['data']['product']['product_image1']" imgType="products" 
                        imgSize="xs" imagePreload alt = "{{data['data']['product']['description']}}" />
                </div>
                <div class="product-content" fxLayout="column">
                    <h3 class="title">{{data['data']['product']['description']}}</h3>
                </div>
            </div>
            <mat-divider class="divider"></mat-divider>
            <ng-container *ngIf="!!featureTags && featureTags['sf_recurring_msg']; else recurringMsg">
                <p class="product-delivery-date">
                    This product is already in your Recurring Items and is scheduled for delivery on
                    <span *ngIf="data['data']['cart']['check'] !== 'cart'">
                        {{data['data']['cart']['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}. However, please note that if you have canceled the order, skipped this week, or added a vacation, this item will not be delivered. 
                    </span>
                    <span *ngIf="data['data']['cart']['check'] === 'cart'">
                        {{selectedDeliveryCalendar['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}. However, please note that if you have canceled the order, skipped this week, or added a vacation, this item will not be delivered.
                    </span>
                </p>
            </ng-container>
            <ng-template #recurringMsg>
                <p class="product-delivery-date">
                    This product is already in your Recurring Items and it will be delivered on
                    <span *ngIf="data['data']['cart']['check'] !== 'cart'">
                        {{data['data']['cart']['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}} 
                    </span>
                    <span *ngIf="data['data']['cart']['check'] === 'cart'">
                        {{selectedDeliveryCalendar['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}
                    </span>
                </p>
            </ng-template>
            <div class="p-1">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span></span>
                    <ng-container *ngIf="!!featureTags && !featureTags['sf_average_size_message']">
                        <span fxLayoutAlign = "end"  fxFlex.lt-sm="70" *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'" class = "ft-12">(Average size of 1 qty is {{data['data']['product']['sell_in_conv_rate']}} lbs)</span>
                    </ng-container>
                    <ng-container *ngIf="!!featureTags && featureTags['sf_average_size_message']">
                        <span fxLayoutAlign = "end"  fxFlex.lt-sm="70" *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'" class = "ft-12">(Average size is {{data['data']['product']['sell_in_conv_rate']}} lbs)</span>
                    </ng-container>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span>Quantity</span>
                    <div  fxLayout="column"  fxFlex.lt-sm="70">
                        <mat-form-field appearance="outline"  
                            class="customize-mat-form-field reduce-mat-form-field-height">
                            <mat-select *ngIf="(!data['data']['saleId'] && !data['data']['cart']) || (data['data']['cart'] && (data['data']['cart']['check'] === 'recurring' || data['data']['cart']['check'] === 'cart'))" [formControl]="quantityControl" (selectionChange)="cartQuantityUpdate()" (openedChange)="onOpenedChange($event)">
                                <mat-option [value]="data['data']['cart']['quantity']">
                                    {{data['data']['cart']['quantity']}}
                                    <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                        <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                        <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">lbs</span>
                                    </span>
                                </mat-option>
                                <mat-option *ngFor="let quantity of displayedQuantities" [value]="quantity">
                                    {{quantity}}
                                    <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                        <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                        <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">nos</span>
                                    </span>
                                </mat-option>
                            </mat-select>
                            <mat-select *ngIf="data['data']['saleId'] || (data['data']['cart'] && data['data']['cart']['check'] === 'sale')" [formControl]="quantityControl" (selectionChange)="orderQuantityUpdate(data['data'], quantityControl)" (openedChange)="onOpenedChange($event)">
                                <mat-option [value]="data['data']['cart']['quantity']">
                                    {{data['data']['cart']['quantity']}}
                                    <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                        <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                        <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">lbs</span>
                                    </span>
                                </mat-option>
                                <mat-option *ngFor="let quantity of displayedQuantities" [value]="quantity">
                                    {{quantity}}
                                    <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                        <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                        <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">nos</span>
                                    </span>
                                </mat-option>
                                
                            </mat-select>
                            <mat-error *ngIf="quantityControl.hasError('required')">Please choose a quantity</mat-error>
                        </mat-form-field>
                    </div> 
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span>Frequency</span>
                    <mat-form-field appearance="outline" fxFlex.lt-sm="70" 
                        class="customize-mat-form-field reduce-mat-form-field-height">
                        <mat-select [formControl]="frequencyControl" #freqSelect disabled (selectionChange)="recurringUpdate($event, data['data'], 'frequency')" required>
                            <mat-option *ngFor="let frequency of cartFrequencies" [value]="frequency">
                                {{frequency}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="freqSelect.errorState && frequencyControl.hasError('required')">Please choose a frequency</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="p-1">
            <div fxLayout="row" fxLayout.lt-md = "column" fxLayoutAlign="center start">
            <p class=" text-muted " fxShow="false" fxShow.lt-md="true" *ngIf = "!!data['data']['product'].compare_price"><span class = "old-price">{{data['data']['currency']}}
                    <span *ngIf = "!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">{{((data['data']['product']['compare_price'] *  quantityControl.value * data['data']['product']['sell_in_conv_rate']) | number: '1.2-4' | replacecomma)  | number : '1.2-2'}}  </span>
                    <span *ngIf = "(!!data['data']['product']['sell_in_uof'] === false || (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos') )">{{((data['data']['product'].compare_price  *  quantityControl.value) | number: '1.2-4' | replacecomma) | number : '1.2-2'}}  </span>
                  </span> Saved ({{data['data']['product'].savepercentage}}%)</p>                               
                <h3 class="edit-subscription-product-price">
                    {{data['data']['currency']}}
                    {{(data['data']['product']['retail_price'] * data['data']['cart']['quantity']| number: '1.2-4' | replacecomma) | number: '1.2-2'}}
                </h3>
            <p class=" text-muted pd-l-5" fxShow="false" fxShow.gt-sm = "true" *ngIf = "!!data['data']['product'].compare_price"><span class = "old-price">{{data['data']['currency']}}
                    <span *ngIf = "!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'nos'">{{((data['data']['product']['compare_price'] *  quantityControl.value * data['data']['product']['sell_in_conv_rate']) | number: '1.2-4' | replacecomma)  | number : '1.2-2'}}  </span>
                    <span *ngIf = "(!!data['data']['product']['sell_in_uof'] === false || (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'nos') )">{{((data['data']['product'].compare_price  *  quantityControl.value) | number: '1.2-4' | replacecomma) | number : '1.2-2'}}  </span>
            </span> Saved ({{data['data']['product'].savepercentage}}%)</p>                               
            </div>
            
            <div class="product-action">
                <button mat-raised-button class="action-btn" [matMenuTriggerFor]="productActionMenu" #productActionMenuTrigger="matMenuTrigger">
            <span class="label">Action</span>
            <mat-icon class="icon">
              {{productActionMenuTrigger.menuOpen ? 'arrow_drop_up' : 'arrow_drop_down'}}
            </mat-icon>
          </button>
                <mat-menu #productActionMenu="matMenu">
                    <button mat-menu-item (click)="skipRecurringItemFromProduct(data['data'])" *ngIf="data['data']['cart']['delivery_date'] === selectedDeliveryCalendar['delivery_date'] || (data['data']['cart']['check'] === 'cart' && data['data']['cart']['recurring'] === 1) || (data['data']['cart']['check'] === 'sale' && data['data']['cart']['recurring'] === 1) ">
              <mat-icon class="mat-icon-sm">delete</mat-icon>
              <span>Skip this for 
                <span *ngIf = "data['data']['cart']['check'] !== 'cart'">
                    {{data['data']['cart']['delivery_date'] | date: dateFormat}}
                </span>
                <span *ngIf = "data['data']['cart']['check'] === 'cart'">
                    {{selectedDeliveryCalendar['delivery_date'] | date: dateFormat}}
                </span>
              </span>
            </button>
                    <mat-divider class="divider" *ngIf="data['data']['cart']['delivery_date'] === selectedDeliveryCalendar['delivery_date']"></mat-divider>
                    <button mat-menu-item (click)="editRecurringQuantity(data)" *ngIf="data['data']['cart']['delivery_date'] === selectedDeliveryCalendar['delivery_date'] || (data['data']['cart']['check'] === 'cart' && data['data']['cart']['recurring'] === 1) || (data['data']['cart']['check'] === 'sale' && data['data']['cart']['recurring'] === 1) ">
              <mat-icon class="mat-icon-sm">edit</mat-icon>
              <span>Edit Qty for 
                <span *ngIf = "data['data']['cart']['check'] !== 'cart'">
                    {{data['data']['cart']['delivery_date'] | date: dateFormat}}
                </span>
                <span  *ngIf = "data['data']['cart']['check'] === 'cart'">
                    {{selectedDeliveryCalendar['delivery_date'] | date: dateFormat}}
                </span>
              </span>
            </button>
                    <button mat-menu-item (click)="addToThisWeek(data)" *ngIf="data['data']['cart']['delivery_date'] !== selectedDeliveryCalendar['delivery_date'] && (data['data']['cart']['check'] !== 'cart') && (data['data']['cart']['check'] !== 'sale')">
                        <mat-icon class="mat-icon-sm">shopping_cart</mat-icon>
                        <span>Add to this Week</span>
                    </button>
                    <mat-divider class="divider"></mat-divider>
                    <button mat-menu-item (click)="redirectTo('/account/recurring', true)">
                        <mat-icon class="mat-icon-sm">repeat</mat-icon>
                        <span>Manage Recurring Items</span>
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>
    <!-- End -->
    <!-- Change Delivery Date Strat -->
    <div *ngIf="data['msg'] === 'change delivery date'" class="switch-delivery-date">
        <h1 mat-dialog-title>Switch Date?</h1>
        <div mat-dialog-content class="description">
            <p>You are currently checking your delivery list for {{data['previousDate'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}. Do you now want to switch to {{data['calendar']['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}?</p>
        </div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px" class="action-btn">
            <button mat-button matDialogClose="no" class="no-btn">NO</button>
            <button mat-button matDialogClose="yes" class="yes-btn">YES</button>
        </div>
    </div>
    <!-- End -->
    
    <!-- Add Special Instruction Start -->
    <div fxLayout="column" *ngIf="data['msg'] === 'add special instruction' || data['msg'] === 'edit special instruction' || data['msg'] === 'view special instruction'">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px">
            <h1 mat-dialog-title class="popup-title">Order Comments</h1>
            <div class="text-end">
                <button mat-mini-fab color="warn" (click)="closeDialog()">
                    <i class="material-icons" data-icon="close"></i>
                </button>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <mat-form-field class="w-100 delivery-details-spl_instruction" appearance="outline">
            <mat-label>Order Comments</mat-label>
            <textarea [readonly] = "!!specialInstruction && !!data['uuid'] && !!orderComments" [(ngModel)]="specialInstruction" matInput [ngStyle.lt-sm]="{'min-height': '50px'}" placeholder="Order Comments">
          </textarea>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="addSpecialInstruction()" class="mt-1" [disabled] = "!!specialInstruction && !!data['uuid'] && !!orderComments">
          {{ !!data['uuid'] ? 'Save' : 'Add' }}
        </button>
    </div>
    <!-- End -->
    <!-- Unconfirmed Order Exist Start -->
    <div *ngIf="data['msg'] === 'unconfirmed order exist'">
        <h1 mat-dialog-title>
            <span>Order in pending status</span>
        </h1>
        <div mat-dialog-content>
            <p>
                You already have an order in pending status. You can't create new order until the pending order is approved.
            </p>
        </div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
            <button mat-button matDialogClose="close" (click)="redirectTo('/account/orders', true)" color="warn" *ngIf="data['yesBtn']">
            Go back to My Orders
          </button>
            <button mat-button matDialogClose="close" color="warn" *ngIf="data['noBtn']">Close</button>
        </div>
    </div>
    <!-- End -->
    <!-- Delivered Order (OR) CutOffTime Exist Start -->
    <div *ngIf="data['msg'] === 'delivered order or cutofftime exist'">
        <h1 mat-dialog-title>
            <span>{{data['title']}}</span>
        </h1>
        <div mat-dialog-content>
            <p>{{data['displayMessage']}}</p>
        </div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
            <button mat-button matDialogClose="close" (click)="redirectTo('/account/orders', true)" color="warn" *ngIf="data['yesBtn']">
            Go back to My Orders
          </button>
          <button mat-button matDialogClose="close" color="warn" *ngIf="data['noBtn']">Close</button>
        </div>
    </div>
    <!-- End -->
     <!-- Order Start date didn't started -->
    <div *ngIf="data['msg'] === 'order start date'">
        <h1 mat-dialog-title>
            <span>{{data['title']}}</span>
        </h1>
        <div mat-dialog-content>
            <p>{{data['displayMessage']}}</p>
        </div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
            <button mat-button matDialogClose="close" (click)="redirectTo('/account/orders', true)" color="warn" *ngIf="data['yesBtn']">
            Go back to My Orders
          </button>
          <button mat-button matDialogClose="close" color="warn" *ngIf="data['noBtn']">Close</button>
        </div>
    </div>
    <!-- Out Of Stock Popup -->
    <div class="out-of-stock" *ngIf="data['msg'] === 'out of stock product popup'">
        <h1 mat-dialog-title>
            <span>Sold Out</span>
        </h1>
        <div mat-dialog-content class="description">
            <p>{{data['displayMessage']}}</p>
        </div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" class="action-btn">
          <button mat-button matDialogClose="close" color="warn" class="yes-btn">OK</button>
        </div>
    </div>
    <!-- End -->
    <!-- Add Delivery Instruction Start -->
    <div fxLayout="column" *ngIf="data['msg'] === 'add delivery instruction' || data['msg'] === 'update delivery instruction' || data['msg'] === 'view delivery instruction'">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px">
            <h1 mat-dialog-title class="popup-title">Delivery Instruction</h1>
            <div class="text-end">
                <button mat-mini-fab color="primary" id="closeDialog" (click)="closeDialog()">
                    <i class="material-icons" data-icon="close"></i>
                </button>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <form [formGroup] = "deliveryInstructionForm">
            <div *ngFor="let item of storeDetails['instruction']; let i = index;" >
                <section class="example-section" >
                    <div class ="ques">
                        <p>{{item['question']}}</p>
                    </div>
                    <!-- <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "option" formArrayName="delivery">
                        <mat-checkbox color = "primary" class="example-margin" *ngFor = "let option of item['options']; let j = index;" (change)="deliveryOptionSelection($event, i, j)" [checked]="option['checked']" 
                         [value] ="option" [formControlName] = "j">{{option['display']}}</mat-checkbox>
                    </div> -->
                    <div fxLayoutAlign ="center" class="option">
                    <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "options" *ngIf = "i === 0" formArrayName="delivery">
                        <mat-checkbox [disabled] = "data['msg'] === 'view delivery instruction'" color = "primary" class="example-margin" *ngFor = "let option of item['options']; let j = index;"  
                        (change)="instructionSelection($event, j)" [checked]="selection.isSelected(j)" [value] ="option" [formControlName] = "j">{{option['display']}}</mat-checkbox>
                    </div>
                    <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "options" *ngIf = "i === 1" formArrayName="cooler">
                        <mat-checkbox [disabled] = "data['msg'] === 'view delivery instruction'" color = "primary" class="example-margin" *ngFor = "let option of item['options']; let k = index;" 
                        (change)="instructionSelectionSec($event, k)" [checked]="selection2.isSelected(k) " [value] ="option" [formControlName] = "k">{{option['display']}}</mat-checkbox>
                    </div>
                    <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "options" *ngIf = "i === 2" formArrayName="pets">
                        <mat-checkbox [disabled] = "data['msg'] === 'view delivery instruction'" color = "primary" class="example-margin" *ngFor = "let option of item['options']; let l = index;" 
                        (change)="instructionSelectionThird($event, l)" [checked]="selection3.isSelected(l)"    [value] ="option" [formControlName] = "l">{{option['display']}}</mat-checkbox>
                    </div>
                    </div>
                    <div *ngIf = "deliveryInstructionForm.value['pets'][0] === true && i === 2">
                        <mat-form-field class="w-100 delivery-details-spl_instruction" appearance="outline">
                            <textarea [disabled] = "data['msg'] === 'view delivery instruction'" formControlName = "instruction" placeholder = "Will driver be attacked by German Shephard?" matInput [ngStyle.lt-sm]="{'min-height': '50px'}" >
                            </textarea>
                        </mat-form-field>  
                    </div>
                </section>
                <br>
            </div>
               
            <!-- <section class="example-section" >
                <div class ="ques">
                    <p>Where will delivery be made?</p>
                </div>
                <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "option" formArrayName="delivery">
                    <mat-checkbox color = "primary" class="example-margin" *ngFor = "let option of optionSet1; let i = index;" (change)="$event ? 
                    selection.toggle(i) : null" [checked]="selection.isSelected(i)" [value] ="option" [formControlName] = "i">{{option['display']}}</mat-checkbox>
                </div>
    
              </section>
              <br>
              <section class="example-section" >
                  <div class ="ques">
                    <p>Will there be a cooler?</p>
                  </div>
                  <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "option" formArrayName="cooler">
                    <mat-checkbox color = "primary" class="example-margin" *ngFor = "let option of optionSet2; let i = index;" (change)="$event ? 
                    selection2.toggle(i) : null" [checked]="selection2.isSelected(i)" [value] ="option" [formControlName] = "i">{{option['display']}}</mat-checkbox>
                  </div>
              </section>
              <br>
              <section class="example-section" >
                  <div class ="ques">
                        <p>Will there be pet outside?</p>
                  </div>
                  <div fxLayout = "column"   class = "option">
                      <div fxLayout = "row" fxLayoutAlign ="center" fxLayoutGap = "15px" formArrayName="pets">
                        <mat-checkbox color = "primary" class="example-margin" *ngFor = "let option of optionSet3; let i = index;" (change)="$event ? 
                        selection3.toggle(i) : null" [checked]="selection3.isSelected(i)" [value] ="option" [formControlName] = "i">{{option['display']}}</mat-checkbox>
                      </div>
                      <div *ngIf = "selection3.isSelected(0)">
                            <mat-form-field class="w-100 delivery-details-spl_instruction" appearance="outline">
                                <textarea formControlName = "instruction" placeholder = "Will delivery be attacked by German Shephard?" matInput [ngStyle.lt-sm]="{'min-height': '50px'}" >
                                </textarea>
                            </mat-form-field>  
                      </div>
                    
                </div>
              </section> -->
        </form>
       
        <!-- <button *ngIf = "data['msg'] !== 'update delivery instruction'" mat-raised-button color="primary" (click)="addDeliveryInstruction()" class="mt-1" [disabled] = "addingInstruction === true">
            {{ data['msg'] === 'add delivery instruction' ? 'Save' : 'Update' }}
        </button> -->
        <mat-spinner-button fxLayoutAlign = "center" *ngIf = "data['msg'] !== 'view delivery instruction'" [options]="saveButtonOptions" [disabled] = "saveButtonOptions === true" mat-button class = "pd-10" (click)="addDeliveryInstruction()" color = "primary" id="saveBtn">
            {{data['msg'] === 'add delivery instruction' ?  'Save': 'Update'}}</mat-spinner-button>
    
    </div>
    <!-- End -->
    
    <!-- Delivery Instruction Info -->
    <div *ngIf="data['msg'] === 'delivery instruction info'">
            <h1 mat-dialog-title>
                <span>Delivery Instruction Help</span>
            </h1>
            <div mat-dialog-content>
            <ul>
                <li>Tell us in few words on where exactly do you want us to leave the items.</li>
                <li>If you have a cooler, tell us the location of your cooler.</li>
                <li>If your community has a gate code, let us know what it is.</li>
                <li>Do you want us to ring the doorbell during drop off?</li>
    
            </ul>
                <!-- <p>
                    Tell us in few words on where exactly do you want us to leave the items.
                </p>
                <p>If you have a cooler, tell us the location of your cooler.</p>
                <p>If your community has a gate code, let us know what it is.</p>
                <p>Do you want us to ring the doorbell during drop off?</p> -->
            </div>
            <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center">
                <button mat-button matDialogClose="close" >
                    Close
                </button>
            </div>
        </div>
        <!-- End -->
    
    <!-- vacation Date present so cannot save order -->
    <div class="out-of-stock" *ngIf="data['msg'] === 'vacation date present'">
        <div mat-dialog-content class="description">
            <p>{{data['displayMessage']}}</p>
        </div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" class="action-btn">
          <button mat-button matDialogClose="close" color="warn" class="yes-btn">OK</button>
        </div>
    </div>
    <!-- End -->
    
    <!-- Delivery fee alert -->
    
    <h1 mat-dialog-title *ngIf="data['msg'] === 'delivery fee alert'">
        <span >Info</span>
    </h1>
    <div mat-dialog-content *ngIf="data['msg'] === 'delivery fee alert'">
        <p>{{data['display']}} </p>
    </div>
    <div mat-dialog-actions *ngIf="data['msg'] === 'delivery fee alert'" fxLayoutAlign ="end" class = "pd-16"> 
        <button   mat-button *ngIf = "data['showProceedBtn'] === true" matDialogClose="proceed" color="warn">It's ok, save my order</button>
        <button mat-button cdkFocusRegionstart matDialogClose="close" class = "color-grn" >Yes</button>
    </div>
    <!-- end -->
    
    <!-- Minimum Order alert -->
    
    <h1 mat-dialog-title *ngIf="data['msg'] === 'minimum order alert'">
        <span >Info</span>
    </h1>
    <div mat-dialog-content *ngIf="data['msg'] === 'minimum order alert'">
        <p>{{data['display']}} </p>
    </div>
    <div mat-dialog-actions *ngIf="data['msg'] === 'minimum order alert'" fxLayoutAlign ="end" class = "pd-16"> 
        <button   mat-button *ngIf = "data['showProceedBtn'] === true" matDialogClose="proceedsaveorder" color="warn">It's ok, save my order</button>
        <button mat-button cdkFocusRegionstart matDialogClose="close" class = "color-grn" >Cancel</button>
    </div>
    <!-- end -->
    
    <!-- Sign up delivery address alert -->
    
    <h1 mat-dialog-title *ngIf="data['msg'] === 'delivery address alert'">
        <span >{{data['title']}}</span>
    </h1>
    <div mat-dialog-content *ngIf="data['msg'] === 'delivery address alert'">
        <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_waitlist_success_message']">
            <p [innerHTML]="data.display" ></p>
        </ng-container>
        <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_waitlist_success_message']">
            <p>{{data['display']}} </p>
        </ng-container>
    </div>
    <div mat-dialog-actions *ngIf="data['msg'] === 'delivery address alert'" fxLayoutAlign ="end" class = "pd-16"> 
        <button mat-stroked-button color="accent" *ngIf = "data['showProceedBtn'] === true" matDialogClose="{{data['proceed']}}" color="warn">{{data['proceed']}}</button>
        <button mat-stroked-button color="accent" *ngIf = "data['showCloseBtn'] === true" cdkFocusRegionstart matDialogClose="close" class = "color-grn" >{{data['close']}}</button>
    </div>
    <!-- end -->
    
    <!-- Sign up Waiting List popup form -->
    
    <div fxLayout="column" *ngIf="data['msg'] === 'waiting list form'" class="popup-content">
        <div class="text-end">
            <button mat-mini-fab color="warn" matDialogClose="close">
                <i class="material-icons" data-icon="close"></i>
            </button>
        </div>
        <div class="popup-content-below">
        <div fxLayout="row wrap" fxLayoutGap="5px">
            <h1 mat-dialog-title class="popup-title">Expand Service to Your Address</h1>
            <span>Thank you for your interest! It looks like your address isn't in our standard service area just yet. To help us serve you better, please fill out our service request form. This way, a team member can get in touch to explore possible options for you. </span>
        </div>
        <mat-divider class="divider"></mat-divider>
        <form [formGroup] = "waitingListForm">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                  <mat-form-field appearance="outline"  class="w-100">
                    <mat-label>First Name</mat-label>
                    <input matInput placeholder="First name" formControlName="first_name" id="waiting_first_name" required>
                    <mat-error *ngIf="waitingListForm.controls.first_name.errors?.required">First Name is required</mat-error>
                    <mat-error *ngIf="waitingListForm.controls.first_name.hasError('maxlength')">First Name characters should be within 35</mat-error>
                    <mat-error *ngIf="waitingListForm.controls.first_name.hasError('validation')">
                        {{waitingListForm.controls.first_name.errors.message}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                  <mat-form-field appearance="outline"  class="w-100">
                    <mat-label>Last Name</mat-label>
                    <input matInput placeholder="Last name" formControlName="last_name" id="waiting_last_name" required>
                    <mat-error *ngIf="waitingListForm.controls.last_name.errors?.required">Last Name is required</mat-error>
                    <mat-error *ngIf="waitingListForm.controls.last_name.hasError('maxlength')">Last Name characters should be within 35</mat-error>
                    <mat-error *ngIf="waitingListForm.controls.last_name.hasError('validation')">
                        {{waitingListForm.controls.last_name.errors.message}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                    <mat-form-field appearance="outline"  class="w-100">
                      <mat-label>Email</mat-label>
                      <input type="email" matInput placeholder="Email" formControlName="email_id" id="waiting_email_id" required>
                      <mat-error *ngIf="waitingListForm.controls.email_id.errors?.required">Email is required</mat-error>
                      <mat-error *ngIf="waitingListForm.controls.email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                      <mat-error *ngIf="waitingListForm.controls.email_id.hasError('validation')">
                          <span [innerHTML]="waitingListForm.controls.email_id.errors.message | sanitizeHtml"></span>
                      </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                    <mat-form-field appearance="outline"  class="w-100">
                      <mat-label>Verify Email</mat-label>
                      <input type="email" matInput placeholder="Email" formControlName="verify_email_id" id="waiting_verify_email_id" required>
                      <mat-error *ngIf="waitingListForm.controls.verify_email_id.errors?.required">Verify Email is required</mat-error>
                      <mat-error *ngIf="waitingListForm.controls.verify_email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                      <mat-error *ngIf="!!waitingListForm.controls.verify_email_id.hasError('emailMismatch') && !waitingListForm.controls.verify_email_id.hasError('invalidEmail')">Email address mismatch! </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                  <mat-form-field appearance="outline"  class="w-100">
                    <mat-label>Phone Number</mat-label>
                    <input type="tel" matInput placeholder="Phone Number" formControlName="phone_number" id="waiting_phone_number" required [value]="waitingListForm.get('phone_number').value | phone: 'US'">
                    <mat-error *ngIf="waitingListForm.controls.phone_number.errors?.required">Phone Number is required</mat-error>
                    <mat-error *ngIf="waitingListForm.controls.phone_number.hasError('minlength')">Phone Number isn't long enough, minimum of 10 characters</mat-error>
                    <mat-error *ngIf="waitingListForm.controls.phone_number.hasError('validation')">
                        <span [innerHTML]="waitingListForm.controls.phone_number.errors.message | sanitizeHtml"></span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="p-1" fxFlex="100%">
                    <button mat-raised-button color="primary" id="waiting_request" (click)="onWaitingListRequest()">Submit Request</button>
                </div>
                <div mat-dialog-actions *ngIf="data['msg'] === 'waiting list form'" fxLayoutAlign ="end" class = "pd-16"
                fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100%"> 
                    <button mat-stroked-button color="accent" id="waiting_proceed" *ngIf = "data['showProceedBtn'] === true" matDialogClose="close" color="warn">{{data['proceed']}}</button>
                    <!-- <button mat-button (click)="onWaitingListRequest()">Added Request</button> -->
                    <button mat-stroked-button color="accent" id="waiting_close" *ngIf = "data['showCloseBtn'] === true" cdkFocusRegionstart matDialogClose="close" class = "color-grn" >{{data['close']}}</button>
                </div>
            </div>
        </form>
    </div>
    </div>
    <!-- end -->
    
    <!-- Tipping Feature popup -->
    <div fxLayout="column" *ngIf="data['msg'] === 'add tips dialog'" class="tips-popup">
        <div fxLayout="row" fxLayoutAlign="space-between" class="dialog-header">
            <div><span class="tipsTitle">Add Tips</span>
                <div class="tipMessage">
                    <p>Show your Support for the Team at {{data['siteName']}}!</p>
                </div>
            </div>
            <div>
                <button mat-mini-fab color="warn" matDialogClose="close" (click)="closeDialog()">
                    <i class="material-icons" data-icon="close"></i>
                </button>
            </div>
        </div>
        <mat-divider class="divider-1"></mat-divider>
        <div class="tipContainer">        
            <p class="tipThanksMsg mt-1" *ngIf="tipsSettings['thanksMsg'] || tipsSettings['sale_order']">Thank you, we appreciate it!</p>
            <div class="tipPercentageContainer mt-1">
                <div class="perBtn mt-1">
                    <button *ngFor="let option of tipsOption | keyvalue" 
                        mat-button 
                        class="tipOption" 
                        [ngClass]="{'activeTip': selectedTip === option.value, 'btn-clr': selectedTip !== option.value}"
                        (click)="selectTip(option.value)">
                        {{ option.value }}%
                    </button>          
                    <button mat-button class="tipOption" 
                        [ngClass]="{'activeTip': selectedTip === 'None', 'btn-clr': selectedTip !== 'None'}"
                        (click)="selectTip('None')">None</button>
                </div>
                <div class="customTipBtn">
                    <mat-form-field appearance="fill" class="custom-tip-input mt-1">
                        <mat-label>Custom tip</mat-label>
                        <input matInput type="number" min="0" placeholder="Enter custom tip amount" [(ngModel)]="customerRecurringTip" (ngModelChange)="onCustomTipChange()">
                    </mat-form-field>
                    <button mat-button class="tipUpdatebtn" (click)="updateTip()">Update tip</button>
                </div>
            </div>
            <div class="tipWeek mt-1">
                <span *ngIf="!!this.featureTags && !this.featureTags['sf_tipping_feature_2']">
                    <input type="checkbox" name="tip" [(ngModel)]="isRecurringTip"> 
                    Tip only this order (Uncheck to make this a recurring tip. <a target="_blank" routerLink="/account/addresses">Edit or Disable Recurring Tip</a>)
                </span>
                <span *ngIf="!!this.featureTags && this.featureTags['sf_tipping_feature_2']">
                    <input type="checkbox" name="tip" [(ngModel)]="isRecurringTip"> 
                    Tip only this order (Uncheck to make this a recurring tip.<a *ngIf="this.tipsSettings['is_recurring_tips_enabled']" target="_blank" routerLink="/account/addresses"> Edit or Disable Recurring Tip</a>)
                </span>
            </div>
        </div>
    </div>
    <!-- end -->

    <!-- Tipping Feature popup -->
    <div fxLayout="column" *ngIf="data['msg'] === 'add recurring tips dialog'" class="tips-popup">
        <div fxLayout="row" fxLayoutAlign="space-between" class="dialog-header">
            <div><span class="tipsTitle">Add Tips</span>
                <div class="tipMessage">
                    <p>Show your Support for the Team at {{data['siteName']}}!</p>
                </div>
            </div>
            <div>
                <button mat-mini-fab color="warn" matDialogClose="close" (click)="closeDialog()">
                    <i class="material-icons" data-icon="close"></i>
                </button>
            </div>
        </div>
        <mat-divider class="divider-1"></mat-divider>
        <div class="tipContainer">        
            <p class="tipThanksMsg mt-1" *ngIf="tipsSettings['thanksMsg']">Thank you, we appreciate it!</p>
            <div class="tipPercentageContainer mt-1">
                <div class="perBtn mt-1">
                    <button *ngFor="let option of tipsOption | keyvalue" 
                        mat-button 
                        class="tipOption" 
                        [ngClass]="{'activeTip': selectedTip === option.value, 'btn-clr': selectedTip !== option.value}"
                        (click)="selectTip(option.value)">
                        {{ option.value }}%
                    </button>          
                    <button mat-button class="tipOption" 
                        [ngClass]="{'activeTip': selectedTip === 'None', 'btn-clr': selectedTip !== 'None'}"
                        (click)="selectTip('None')">None</button>
                </div>
                <div class="customTipBtn">
                    <mat-form-field appearance="fill" class="custom-tip-input mt-1">
                        <mat-label>Custom tip</mat-label>
                        <input matInput type="number" min="0" placeholder="Enter custom tip amount" [(ngModel)]="customerRecurringTip" (ngModelChange)="onCustomTipChange()">
                    </mat-form-field>
                    <button mat-button class="tipUpdatebtn" (click)="updateTips()">Update tip</button>
                </div>
            </div>
            <div class="tipWeek mt-1">
                <span *ngIf="!!this.featureTags && !this.featureTags['sf_tipping_feature_2']">
                    <input type="checkbox" name="tip" [(ngModel)]="isRecurringTip"> 
                    Tip only this order (Uncheck to make this a recurring tip. <a target="_blank" routerLink="/account/addresses">Edit or Disable Recurring Tip</a>)
                </span>
                <span *ngIf="!!this.featureTags && this.featureTags['sf_tipping_feature_2']">
                    <input type="checkbox" name="tip" [(ngModel)]="isRecurringTip"> 
                    Tip only this order (Uncheck to make this a recurring tip.<a *ngIf="this.tipsSettings['is_recurring_tips_enabled']" target="_blank" routerLink="/account/addresses"> Edit or Disable Recurring Tip</a>)
                </span>
            </div>
        </div>
    </div>
    <!-- end -->
    
    <!-- Save Order alert for unsaved cart products -->
    <div class="save-order-alert" *ngIf="data['msg'] === 'save order alert'">
        <h4 class="save-order-alert-heading">Don’t Forget to Save Your Order!</h4>
        <div mat-dialog-content class="save-order-alert-text">
            <p>You have items in your cart. If you close or navigate away from this page now, your delivery won’t be scheduled, and you may lose your items.</p>
        </div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" class="action-btn save-btn-alert">
          <button mat-raised-button (click)="saveLater()">Save Later</button>
          <button mat-raised-button class="save" color='primary' (click)="saveOrderNow()">Save Order</button>
        </div>
    </div>
    <!-- End -->
</ng-container>

<ng-container *ngIf="!!featureTags && featureTags['sf_nos_to_unit']">
    <ng-container *ngIf="!!featureTags && !featureTags['ftag_cod_and_other_payment_for_sf']">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" *ngIf="data['msg'] === 'Credit card Not Found'">
            <h1 mat-dialog-title>You don't have any active Payment Option!</h1>
            <div class="text-end">
                <button mat-mini-fab color="warn" (click)="closeDialog()">
                <i class="material-icons" data-icon="close"></i>
              </button>
            </div>
        </div>
        <div mat-dialog-content *ngIf="data['msg'] === 'Credit card Not Found'">
            <p>We have introduced an automatic billing system to our website and it requires the end customer to input the credit card information safely in a secure environment. Please add your credit card so that you can save this order. </p>
        </div>
        <div mat-dialog-actions fxLayoutAlign="end" fxLayout="row" class="mb-5" *ngIf="data['msg'] === 'Credit card Not Found'">
            <button mat-raised-button (click)="goToPayment()" class="proceed-payment-btn">
            Proceed to Payment Options
          </button>
        </div>
    </ng-container>
    <ng-container *ngIf="!!featureTags && featureTags['ftag_cod_and_other_payment_for_sf']">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" *ngIf="data['msg'] === 'Credit card Not Found' || data['msg'] === 'Cash On Delivery'">
            <h1 mat-dialog-title>You don't have any active Payment Option!</h1>
            <div class="text-end">
                <button mat-mini-fab color="warn" (click)="closeDialog()">
                <i class="material-icons" data-icon="close"></i>
              </button>
            </div>
        </div>
        <div mat-dialog-content *ngIf="data['msg'] === 'Credit card Not Found' || data['msg'] === 'Cash On Delivery'">
            <p>We have introduced an automatic billing system to our website and it requires the end customer to input the credit card information safely in a secure environment. Please add your credit card so that you can save this order. </p>
        </div>
        <div mat-dialog-actions fxLayoutAlign="end" fxLayout="row" class="mb-5" *ngIf="data['msg'] === 'Credit card Not Found' || data['msg'] === 'Cash On Delivery'">
            <button mat-raised-button *ngIf="data['msg'] === 'Cash On Delivery'" matDialogClose="Pay Later" color="primary" class="proceed-payment-btn" [disabled]="isDisabledPaylater" (click)="enablePaylater(data['type'])">
                Pay Later
              </button>
            <button mat-raised-button 
                (click)="data['msg'] === 'Credit card Not Found' ? goToPayment() : goToPaymentOption()" 
                class="proceed-payment-btn">
                Proceed to Payment Options
            </button>
        </div>
    </ng-container>


<h1 mat-dialog-title *ngIf="data['msg'] === 'delete credit card'"> Delete Credit Card</h1>
<div mat-dialog-content *ngIf="data['msg'] === 'delete credit card'">
    <p>Are you sure you want to delete this Card? </p>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'delete credit card'" fxLayoutAlign ="end">
    <button mat-button matDialogClose="delete" color="warn">Delete</button>
    <button mat-button matDialogClose="cancel">Cancel</button>
</div>


<h1 mat-dialog-title *ngIf="data['msg'] === 'cut off time error'">
    <span>Order cutoff time</span>
    <!-- <span *ngIf="selectedDeliveryCalendar !== null &&  selectedDeliveryCalendar['create_order'] === false"> Over and done</span> -->
</h1>
<h1 mat-dialog-title *ngIf="data['msg'] === 'existing product'">
    <span>Item Already in Your Order!</span>
</h1>
<h1 mat-dialog-title *ngIf="data['msg'] === 'existing recurring'">
    <span>Item Already in Your Recurring!</span>
</h1>
<h1 mat-dialog-title *ngIf="data['msg'] === 'order skipped'">
    <span>Order Skipped</span>
    <!-- <span *ngIf="selectedDeliveryCalendar !== null &&  selectedDeliveryCalendar['create_order'] === false"> Over and done</span> -->
</h1>
<h1 mat-dialog-title *ngIf="data['msg'] === 'unskip'">
    <span>Unskipped Order</span>
    <!-- <span *ngIf="selectedDeliveryCalendar !== null &&  selectedDeliveryCalendar['create_order'] === false"> Over and done</span> -->
</h1>
<div mat-dialog-content *ngIf="data['msg'] === 'cut off time error' || data['msg'] === 'order skipped' || data['msg'] === 'unskip' || data['msg'] === 'existing product'  || data['msg'] === 'existing recurring' ">
    <p>{{data['display']}} </p>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'cut off time error' || data['msg'] === 'existing product'  || data['msg'] === 'existing recurring'" fxLayoutAlign ="end"> 
    <button mat-button matDialogClose="close" color="warn">Okay</button>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'order skipped'" fxLayoutAlign ="end"> 
    <button mat-button *ngIf="router.url !== '/account/orders'" matDialogClose="close" 
        (click)="redirectTo('/account/orders', true)" color="warn">Go back to My Orders</button>
    <button mat-button *ngIf="router.url === '/account/orders'" matDialogClose="close" color="warn">Close</button>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'unskip'" fxLayoutAlign ="end"> 
    <button mat-button matDialogClose="proceed" color="warn">Proceed</button>
    <button mat-button matDialogClose="close" color="warn">Close</button>
</div>

<h1 mat-dialog-title *ngIf="data['msg'] === 'failed to add'">
    Failed to Add Cart
</h1>
<div mat-dialog-content *ngIf="data['msg'] === 'failed to add'">
    <p>{{data['display']}} </p>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'failed to add'" fxLayoutAlign ="end"> 
    <button mat-button matDialogClose="close" color="warn">Close</button>    
</div>

<h1 mat-dialog-title *ngIf="!!featureTags && featureTags['ftag_allow_product_to_customer_based_events'] && data['restrict_product']">
    Product Not Available
</h1>
<div mat-dialog-content *ngIf="!!featureTags && featureTags['ftag_allow_product_to_customer_based_events'] && data['restrict_product']">
    <p>{{data['msg']}} </p>
</div>
<div mat-dialog-actions *ngIf="!!featureTags && featureTags['ftag_allow_product_to_customer_based_events'] && data['restrict_product']" fxLayoutAlign ="end"> 
    <button mat-button matDialogClose="close" color="warn">Close</button>    
</div>

<h1 mat-dialog-title *ngIf="data['msg'] === 'order start date error'">
    <span *ngIf="selectedDeliveryCalendar !== null && selectedDeliveryCalendar['create_order'] === true">Order Availability Notice</span>
</h1>
<div mat-dialog-content *ngIf="data['msg'] === 'order start date error'">
    <p>{{data['display']}} </p>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'order start date error'" fxLayoutAlign ="end"> 
    <button mat-button *ngIf="router.url !== '/account/orders'" matDialogClose="close" 
        (click)="redirectTo('/account/orders', true)" color="warn">Go back to My Orders</button>
    <button mat-button *ngIf="router.url === '/account/orders'" matDialogClose="close" color="warn">Close</button>
</div>

<!-- Delivery Preference Dialog Start -->
<div class="close-btn-outer" *ngIf="data['msg'] === 'Delivery Preference'">
    <button mat-mini-fab matDialogClose="close" color="warn"><i class="material-icons" data-icon="close"></i></button>
</div>
<div mat-dialog-content class="DeliveryPreferenceDialog" *ngIf="data['msg'] === 'Delivery Preference'" fxLayoutAlign ="end">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex="100">
        <mat-card class="p-0">
            <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
                <mat-card-title class="m-0"><h3>{{data['deliveryPreference']}} Address</h3></mat-card-title>
            </mat-card-header>
            <div class="divider"></div>
            <mat-card-content class="p-2 text-muted account-card-content">
                <p *ngIf="data['pickupLocName']"><b>Pickup Location - {{data['pickupLocName']}}</b></p>
                <p *ngIf="data['address']">{{data['address']}}</p>
                <p *ngIf="data['city']">{{data['city']}}</p>
                <p *ngIf="data['county']">{{data['county']}}</p>
                <p *ngIf="data['state'] || data['zipcode']">{{data['state']}} {{data['zipcode']}}</p>
                <p *ngIf="data['deliveryDays']"><strong>Delivery Days : </strong><span  [ngStyle]="{'color': '#C62828'}"> {{data['deliveryDays']}}</span></p>
                <p *ngIf="data['locationNotes']"><strong>Notes : </strong><span  [ngStyle]="{'color': '#C62828'}"> {{data['locationNotes']}}</span></p>
            </mat-card-content>
        </mat-card>
    </div>   
</div>
<div fxLayout="row wrap"  *ngIf="data['msg'] === 'Delivery Preference'"  fxLayoutAlign="space-between center" class="mt-1 dpchangeBtn">
    <button (click)="closeDialog()" mat-raised-button color="primary" routerLink="/account/addresses">Change</button>
</div>
<!-- Delivery Preference Dialog End -->

<!-- Coupon Apply or Edit Dialog Start -->

<div class="CouponsDialogDiv" *ngIf="data['msg'] === 'Coupons Apply'">
    <div fxLayout="row">
        <h2 mat-dialog-title fxFlex class="popup-title">APPLY COUPON</h2>
        <div fxFlex class="text-end">
            <button mat-mini-fab color="warn" (click)="closeDialog()"><i class="material-icons" data-icon="close"></i>
            </button>
        </div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div mat-dialog-content class="CouponsDialog">
        <div fxLayout="row" class = "couponDiv">
            <div fxFlex = "70" class="couponInputDiv" fxLayoutAlign="space-between center">
                <input matInput [(ngModel)]="couponCode" placeholder="Enter coupon code">
            </div>
            <div fxLayoutAlign="end" fxFlex = "30">
                <button mat-button class = "couponbtn btn-clr" (click)="applyCoupon(data['coupons'])" 
                [disabled]="isLoadingCouponBtn" [ngClass]="{'routeworx-spinner spinner-style3': isLoadingCouponBtn}" id="applyCoupon">
                    <span>APPLY</span>
                </button> 
            </div>
        </div>
        <mat-error class="{{couponError['class']}}" *ngIf="couponError['message']">
            {{couponError['message']}}
        </mat-error>
        <mat-divider class="divider"></mat-divider>
        <div class="p-1">
            <div fxLayout="row" class="appliedCoupons" *ngFor="let coupon of data['coupons']">
               <div class="appliedCouponsRow p-1" fxLayoutAlign="space-between center">
                    <h5 *ngIf="coupon['extended_price'] && coupon['extended_price']>0">
                        <div class="couponCodeDiv">
                            <!-- <mat-checkbox class="couponCheckBox" matInput [id]="'couponCheckbox_'+ coupon['coupon_code']" [(ngModel)]="isCheckedCoupon[coupon['coupon_code']]" color="primary">
                            </mat-checkbox>&nbsp; -->
                            <!-- <input type="checkbox" class="couponCheckBox" id="couponCheckbox_{{coupon['coupon_code']}}" name="couponCheckbox_{{coupon['coupon_code']}}" checked> -->
                            <!-- <mat-icon class="couponsDiscountIcon" aria-hidden="false">discount</mat-icon>&nbsp; -->
                            <span class="couponCodeSpn">{{coupon['coupon_code']}}</span>
                            <span class="couponBenefit"> Save {{data['currency']}}{{coupon['extended_price'] | number: '1.2-2'}}</span>
                        </div>
                        <div class="couponInfo">
                            <br><span class="couponDesc">{{coupon['coupon_desc']}}</span>
                        </div>
                    
                    </h5>
                <mat-icon class="couponsDeleteIcon" (click)="deleteCoupon(coupon)" aria-hidden="false" id="deleteCoupon">delete_outline</mat-icon>
               </div>
                <mat-divider class="divider"></mat-divider>
               <!-- <span>&nbsp;&nbsp;</span>
                <h5 class="couponsPrice" *ngIf="coupon['extended_price'] && coupon['extended_price']>0">{{data['currency']}}<span>{{coupon['extended_price'] | number: '1.2-2' }}</span></h5> -->
            </div>
        </div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center start">
            <div class="lbl">
                <p class="couponsTotalAmount" fxShow.lt-md="true">Maximum savings :&nbsp;</p>
            </div>
            <p class="couponsTotalAmount" fxShow.lt-md="true">
                <span > {{data['currency']}}{{couponsTotalAmount  | number: '1.2-2'}}</span>
            </p>
        </div>
        
        <!-- <div class="product-action">
            <button *ngIf="data['coupons']" mat-raised-button (click)="applyCoupon(data['coupons'])" class="btn-add">
                APPLY
            </button>
        </div> -->
    </div>
</div>
<!-- Coupon Coupon Apply or Edit Dialog End -->

<!-- Coupon Details Dialog Start -->
<div class="close-btn-outer" *ngIf="data['msg'] === 'Coupon Details'">
    <button mat-mini-fab matDialogClose="close" color="warn"><i class="material-icons" data-icon="close"></i></button>
</div>
<div mat-dialog-content class="DeliveryPreferenceDialog" *ngIf="data['msg'] === 'Coupon Details' && data['coupons']" fxLayoutAlign ="end">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex="100">
        <mat-card class="p-0">
            <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
                <mat-card-title class="m-0"><h3>Applied Coupons</h3></mat-card-title>
            </mat-card-header>
            <div class="divider"></div>
            <mat-card-content class="text-muted couponList" *ngFor="let coupon of data['coupons']">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <h5 *ngIf="coupon['extended_price'] && coupon['extended_price']>0"><mat-icon class="couponsPrice" aria-hidden="false">discount</mat-icon>&nbsp;{{coupon['coupon_code']}}</h5>
                    <span>&nbsp;&nbsp;</span>
                    <h5 class="couponsPrice" *ngIf="coupon['extended_price'] && coupon['extended_price']>0">{{data['coupons']['currency']}}<span>{{coupon['extended_price'] | number: '1.2-2' }}</span></h5>
                </div>
            </mat-card-content>
        </mat-card>
    </div>   
</div>
<!-- Coupon Details Dialog End -->

<!-- Tax Details Dialog Start -->
<div class="close-btn-outer" *ngIf="data['msg'] === 'Tax Details'">
    <button mat-mini-fab matDialogClose="close" color="warn"><i class="material-icons" data-icon="close"></i></button>
</div>
<div mat-dialog-content class="DeliveryPreferenceDialog" *ngIf="data['msg'] === 'Tax Details' && data['taxesInfo']" fxLayoutAlign ="end">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex="100">
        <mat-card class="p-0 taxDetailsDiv">
            <mat-card-header fxLayout="column" class="p-1 account-card-title" fxLayoutAlign="space-between center">
                <mat-card-title class="m-0"><h3>Tax Details</h3></mat-card-title>
            </mat-card-header>
            <div class="divider"></div>
            <div *ngFor="let tax of data['taxesInfo']">
                <mat-card-content class="text-muted couponList" *ngIf="tax['product_tax'] && tax['product_tax'].length>0">
                        <div fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let ptax of tax['product_tax']">
                            <h5 *ngIf="ptax['tax_name'] && ptax['ext_tax']>0">{{ptax['tax_name']}}&nbsp;({{ptax['tax_percentage'] ? ptax['tax_percentage'] : ptax['tax_rate_percentage'] }}%)</h5>
                            <span>&nbsp;&nbsp;</span>
                            <h5 *ngIf="ptax['tax_name'] && ptax['ext_tax']>0">{{data['currency']}}<span>{{ptax['ext_tax'] | number: '1.2-2' }}</span></h5>
                        </div>
                </mat-card-content>
            </div>
        </mat-card>
    </div>   
</div>
<!-- Tax Details Dialog End -->

<!-- Edit Subscription Dialog Start -->
<div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" *ngIf="data['msg'] === 'edit subscription'">
    <h1 mat-dialog-title>Edit Recurring Items</h1>
    <div class="text-end">
        <button mat-mini-fab color="warn" (click)="closeDialog()">
            <i class="material-icons" data-icon="close"></i>
        </button>
    </div>
</div>
<div mat-dialog-content *ngIf="data['msg'] === 'edit subscription'">
    <div class="product" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
        <div class="product-img">
            <img src="data:," [imgName]="data['data']['product']['product_image1']" imgType="products" 
            imgSize="xs" imagePreload alt = "{{data['data']['description']}}" />
        </div>
        <div class="product-content" fxLayout="column">
            <h3 class="title">{{data['data']['description']}}</h3>
            <div fxLayout="row"  fxLayoutAlign=" start">
                <p class="price">{{data['data']['currency']}}
                    {{(data['data']['product']['retail_price'] * data['data']['quantity'] | number: '1.2-4' | replacecomma) | number: '1.2-2'}}
                </p>
            <p class=" text-muted pd-l-5" *ngIf = "!!data['data']['product'].compare_price"><span class = "old-price">{{data['data']['currency']}}
                    <span *ngIf = "!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">{{((data['data']['product']['compare_price'] *  quantityControl.value * data['data']['product']['sell_in_conv_rate']) | number: '1.2-4' | replacecomma)  | number : '1.2-2'}}  </span>
                    <span *ngIf = "(!!data['data']['product']['sell_in_uof'] === false || (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit') )">{{((data['data']['product'].compare_price  *  quantityControl.value) | number: '1.2-4' | replacecomma) | number : '1.2-2'}}  </span>
            </span> Saved ({{data['data'].savepercentage}}%)</p>                               
            </div>
           
        </div>
    </div>
    <div class="prod_status" fxLayout="row"  fxLayoutGap="20px"> 
        <div class="btl product_bottle" *ngIf="data['data']['product']['bottle_charge']">
            <span  fxLarout="row" fxLayoutAlign="center center">
                <img src = "assets/images/others/bottle-icon.png" alt = "Bottle present"> <span>Glass bottle</span>
            </span>
        </div>
        <div class="btl warn product_stock mr-0" *ngIf="data['data']['product_status'] || data['data']['product']['is_delete']">
            <span  fxLarout="row" fxLayoutAlign="center center">
                <mat-icon>clear</mat-icon>Sold Out
            </span>
        </div>
        <div class = "lbs_product" *ngIf="data['data']['product']['cb_unit_of_measurement']['acronym'] === 'lbs'">
            <span  fxLarout="row" 
            fxLayoutAlign="center center">
              <img src="assets/images/lbs.png" alt ="Lbs product"> 
            </span>
        </div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <!-- <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px"> -->
        <!-- <div fxFlex="35" class="product-dates">
            <p class="delivery-day">DeliveryDay</p>
            <p class="day-name">{{data['data']['deliveryDay'] | titlecase}}</p>
        </div> -->
        <!--<div fxFlex="35" class="product-dates" *ngIf="!data['data']['cart']">
            <p class="last-delivery">Last <br fxShow="false" fxShow.lt-sm>Delivered:</p>
            <p class="last-date" *ngIf="data['data']['last_recurring_date'] === false">NIL</p>
            <p class="last-date" *ngIf="data['data']['last_recurring_date'] !== false">
                {{data['data']['last_recurring_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}
            </p>
        </div> -->
        <!-- <div fxFlex="35" class="product-dates" *ngIf="!data['data']['skipped_delivery'] && !data['data']['cart']">
            <p class="next-delivery">
                Next Delivery:</p>
            <p class="next-date">
                {{data['data']['recurring_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}
            </p>
        </div> -->
    <!-- </div> -->
    <!-- <mat-divider class="divider"></mat-divider> -->
    <p><b>Change Qty (Subscribed for <span *ngIf = "data['data']['recurring_qty']">{{data['data']['recurring_qty']}}</span><span *ngIf = "!data['data']['recurring_qty']">{{data['data']['quantity']}}</span>
        <span *ngIf ="data['data']['product']['cb_unit_of_measurement']['name'] === 'Weight in 1lbs'">lbs</span>)</b></p>
    <div class="product-form" fxLayout="column">
        <ng-container *ngIf="!!featureTags && !featureTags['sf_average_size_message']">
            <span  fxFlex="50" *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'" class = "ft-12">(Average size of 1 qty is {{data['data']['product']['sell_in_conv_rate']}} {{data['data']['product']['cb_unit_of_measurement']['acronym']}})</span>
        </ng-container>
        <ng-container *ngIf="!!featureTags && featureTags['sf_average_size_message']">
            <span  fxFlex="50" *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'" class = "ft-12">(Average size is {{data['data']['product']['sell_in_conv_rate']}} {{data['data']['product']['cb_unit_of_measurement']['acronym']}})</span>
        </ng-container>
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div fxLayout="column"  fxFlex="50">
                <mat-form-field appearance="outline" 
                    class="product-quantity customize-mat-form-field reduce-mat-form-field-height">
                    <!-- <mat-label>Quantity</mat-label> -->
                        <mat-select [formControl]="quantityControl"
                        [disabled]="data['data']['turnDisabled'] || (data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" (openedChange)="onOpenedChange($event)">
                        <mat-option *ngIf="!displayedQuantities.includes(data['data']['quantity'])" [value]="data['data']['quantity']">
                            {{ (data['data']['product']['sell_in_uof'] === 'unit' && data['data']['product']['cb_unit_of_measurement']['acronym'] === 'lbs') ? (data['data']['quantity'] / data['data']['product']['sell_in_conv_rate']) : data['data']['quantity'] }}
                            <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">unit</span>
                            </span>
                        </mat-option>                    
                        <mat-option *ngFor="let quantity of displayedQuantities" [value]="quantity">
                            {{ (data['data']['product']['sell_in_uof'] === 'unit' && data['data']['product']['cb_unit_of_measurement']['acronym'] === 'lbs') ? (quantity / data['data']['product']['sell_in_conv_rate']) : quantity }}
                            <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">unit</span>
                            </span>
                        </mat-option>
                        </mat-select>
                </mat-form-field>
            </div>
            
            <div fxFlex="50" fxLayoutGap="5px" fxLayoutAlign = "center">
                <button mat-raised-button fxFlex="50"  *ngIf="data['data']['turnDisabled'] === true"
                [disabled]="(data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                (click)="enableProduct(data['data'], quantityControl)">Edit</button>
                <div class="button-container" >
                    <div class="spinner-container" *ngIf="data['data']['qtyLoad'] && (!data['data']['saleId'] && !data['data']['cart']) || (data['data']['cart'] && (data['data']['cart']['check'] === 'recurring' || data['data']['cart']['check'] === 'cart'))">
                    <mat-spinner diameter="24"></mat-spinner>
                    </div>
                    <button mat-raised-button fxFlex="50" 
                    *ngIf="data['data']['turnDisabled'] === false && (!data['data']['saleId'] && !data['data']['cart']) || (data['data']['cart'] && (data['data']['cart']['check'] === 'recurring' || data['data']['cart']['check'] === 'cart'))" [disabled]="data['data']['qtyLoad'] || (data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                    (click)="recurringQuantityUpdate(data['data'], quantityControl)">Update</button>
                </div>
                <div class="button-container" >
                    <div class="spinner-container" *ngIf="data['data']['qtyLoad'] && (data['data']['saleId'] || (data['data']['cart'] && data['data']['cart']['check'] === 'sale'))">
                    <mat-spinner diameter="24"></mat-spinner>
                    </div>
                    <button mat-raised-button fxFlex="50" 
                    *ngIf="data['data']['turnDisabled'] === false && (data['data']['saleId'] || (data['data']['cart'] && data['data']['cart']['check'] === 'sale'))"  [disabled]="data['data']['qtyLoad'] || (data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                    (click)="orderQuantityUpdate(data['data'], quantityControl)">Update</button>
                </div>
                <button mat-raised-button fxFlex="50" 
                *ngIf="data['data']['turnDisabled'] === false"
                (click)="cancel(data['data'])">Cancel</button>
            </div>
           
        </div>
        <div class="mt-7px" *ngIf="data['data']['turnDisabled'] === false">
            <mat-radio-group aria-label="Select an option" class="ft-sz" 
            [disabled]="(data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
            (change)="handleChange($event)" fxLayoutGap="10px">
                <mat-radio-button [value]="option['value']" class="color" [checked]="option['checked']" 
                    *ngFor="let option of radioButtonOptions">{{option['display']}}</mat-radio-button>
            </mat-radio-group>
        </div>
        <mat-divider class="divider"></mat-divider>
        <p><b>Edit Frequency</b></p>
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <mat-form-field fxFlex="50" appearance="outline" 
                class="w-100 product-frequency customize-mat-form-field reduce-mat-form-field-height">
                <mat-select [formControl]="frequencyControl" [disabled]="data['data']['turnFreqDisabled'] === true || (data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" >
                    <mat-option *ngFor="let frequency of cartFrequencies" [value]="frequency">
                        {{frequency}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div fxFlex="50" fxLayoutGap="5px" fxLayoutAlign = "center">
                <button mat-raised-button fxFlex="50"  *ngIf="data['data']['turnFreqDisabled'] === true"
                [disabled]="(data['data']['product_status'] || data['data']['product']['is_delete']) === true ? true : false" 
                (click)="enableProductFrequency(data['data'], quantityControl)">Edit</button>
                <div class="button-container" >
                    <div class="spinner-container" *ngIf="data['data']['freqLoad']">
                    <mat-spinner diameter="24"></mat-spinner>
                    </div>
                    <button mat-raised-button fxFlex="50" *ngIf="data['data']['turnFreqDisabled'] === false" [disabled] ="data['data']['freqLoad']"
                    (click)="recurringUpdate($event, data['data'], 'frequency')">Update</button>
                </div>
                <button mat-raised-button fxFlex="50" 
                *ngIf="data['data']['turnFreqDisabled'] === false"
                (click)="cancelFrequency(data['data'])">Cancel</button>
            </div>
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="10px" *ngIf="showStartDate">
        <div>
            Start Date: {{data['data']['recurring_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}
        </div>
        <div fxLayout="row" fxLayoutGap="10px" *ngIf="this.url === '/edit-order' || this.url === '/account/recurring'">
            <mat-icon>calendar_today</mat-icon>
            <ng-container *ngIf="!!featureTags && !featureTags['recurring_start_date_not_considered_in_sf'];else disableChangeDate">
                <div (click)="picker.open()" class="start-date" >Change Start Date</div>
            </ng-container>
            <ng-template #disableChangeDate>
                <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_wrong_holiday_recurring_dates']">
                    <div class="start-date" [ngClass]="{ 'isDisabledDatepicker': isDisabledDatepicker }" (click)="!isDisabledDatepicker && fetchDatesAndOpenDatepicker(picker, data['data']['id'])"> Change Start Date</div>
                </ng-container>
                <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_wrong_holiday_recurring_dates']">
                    <div class="start-date" [ngClass]="{ 'isDisabledDatepicker': isDisabledDatepicker }" (click)="!isDisabledDatepicker && picker.open()"> Change Start Date </div>
                </ng-container>
            </ng-template>
        </div>
        <mat-form-field class="example-full-width" fxHide>
            <input matInput [matDatepicker]="picker" (dateInput)="addEvent('input', $event)" (dateChange)="addEvent('change', $event)" [matDatepickerFilter]="deliveryDayFilter" [min]="minDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div class="subscription-cancel" fxLayout="column" fxLayoutGap="10px">
        <!-- <button mat-raised-button *ngIf = "data['data']['cart'] && data['data']['cart']['delivery_date'] === ''" (click) = "addToThisWeek(data)">Add To This  Week </button> -->
        <button mat-raised-button (click)="stopRecurring(data['data'])" color="primary">Stop this item</button>
    </div>
    <div class="mt-2" *ngIf="router.url !== '/account/recurring'">
        <a [routerLink]="['/account/recurring']" (click)="closeDialog()" matTooltip="View all Recurring Products">View all Recurring Items</a>
    </div>
</div>
<!-- End -->

<!-- Edit Subscription Form Products Strat -->
<div fxLayout="column" *ngIf="data['msg'] === 'edit subscription from products'">
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px">
        <h1 mat-dialog-title class="popup-title">Already in Recurring </h1>
        <div class="text-end">
            <button mat-mini-fab color="warn" (click)="closeDialog()">
                <i class="material-icons" data-icon="close"></i>
            </button>
        </div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div mat-dialog-content>
        <div class="product" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
            <div class="product-img">
                <img src="data:," [imgName]="data['data']['product']['product_image1']" imgType="products" 
                    imgSize="xs" imagePreload alt = "{{data['data']['product']['description']}}" />
            </div>
            <div class="product-content" fxLayout="column">
                <h3 class="title">{{data['data']['product']['description']}}</h3>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <ng-container *ngIf="!!featureTags && featureTags['sf_recurring_msg']; else recurringMsg">
            <p class="product-delivery-date">
                This product is already in your Recurring Items and is scheduled for delivery on
                <span *ngIf="data['data']['cart']['check'] !== 'cart'">
                    {{data['data']['cart']['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}. However, please note that if you have canceled the order, skipped this week, or added a vacation, this item will not be delivered. 
                </span>
                <span *ngIf="data['data']['cart']['check'] === 'cart'">
                    {{selectedDeliveryCalendar['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}. However, please note that if you have canceled the order, skipped this week, or added a vacation, this item will not be delivered.
                </span>
            </p>
        </ng-container>
        <ng-template #recurringMsg>
            <p class="product-delivery-date">
                This product is already in your Recurring Items and it will be delivered on
                <span *ngIf="data['data']['cart']['check'] !== 'cart'">
                    {{data['data']['cart']['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}} 
                </span>
                <span *ngIf="data['data']['cart']['check'] === 'cart'">
                    {{selectedDeliveryCalendar['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}
                </span>
            </p>
        </ng-template>
        <div class="p-1">
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                <span></span>
                <ng-container *ngIf="!!featureTags && !featureTags['sf_average_size_message']">
                    <span fxLayoutAlign = "end"  fxFlex.lt-sm="70" *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'" class = "ft-12">(Average size of 1 qty is {{data['data']['product']['sell_in_conv_rate']}} {{data['data']['product']['cb_unit_of_measurement']['acronym']}})</span>
                </ng-container>
                <ng-container *ngIf="!!featureTags && featureTags['sf_average_size_message']">
                    <span fxLayoutAlign = "end"  fxFlex.lt-sm="70" *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'" class = "ft-12">(Average size is {{data['data']['product']['sell_in_conv_rate']}} {{data['data']['product']['cb_unit_of_measurement']['acronym']}})</span>
                </ng-container>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                <span>Quantity</span>
                <div  fxLayout="column"  fxFlex.lt-sm="70">
                    <mat-form-field appearance="outline"  
                        class="customize-mat-form-field reduce-mat-form-field-height">
                        <mat-select *ngIf="(!data['data']['saleId'] && !data['data']['cart']) || (data['data']['cart'] && (data['data']['cart']['check'] === 'recurring' || data['data']['cart']['check'] === 'cart'))" [formControl]="quantityControl" (selectionChange)="cartQuantityUpdate()" (openedChange)="onOpenedChange($event)">
                            <mat-option [value]="data['data']['cart']['quantity']">
                                {{data['data']['cart']['quantity']}}
                                <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                    <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                    <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">lbs</span>
                                </span>
                            </mat-option>
                            <mat-option *ngFor="let quantity of displayedQuantities" [value]="quantity">
                                {{quantity}}
                                <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                    <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                    <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">unit</span>
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-select *ngIf="data['data']['saleId'] || (data['data']['cart'] && data['data']['cart']['check'] === 'sale')" [formControl]="quantityControl" (selectionChange)="orderQuantityUpdate(data['data'], quantityControl)" (openedChange)="onOpenedChange($event)">
                            <mat-option [value]="data['data']['cart']['quantity']">
                                {{data['data']['cart']['quantity']}}
                                <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                    <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                    <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">lbs</span>
                                </span>
                            </mat-option>
                            <mat-option *ngFor="let quantity of displayedQuantities" [value]="quantity">
                                {{quantity}}
                                <span *ngIf="!!data['data']['product']['cb_unit_of_measurement']['acronym']">
                                    <span *ngIf ="(!!data['data']['product']['sell_in_uof'] === false ||  (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit' ) ) ">{{data['data']['product']['cb_unit_of_measurement']['acronym']}}</span>
                                    <span *ngIf ="!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">unit</span>
                                </span>
                            </mat-option>
                            
                        </mat-select>
                        <mat-error *ngIf="quantityControl.hasError('required')">Please choose a quantity</mat-error>
                    </mat-form-field>
                </div> 
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                <span>Frequency</span>
                <mat-form-field appearance="outline" fxFlex.lt-sm="70" 
                    class="customize-mat-form-field reduce-mat-form-field-height">
                    <mat-select [formControl]="frequencyControl" #freqSelect disabled (selectionChange)="recurringUpdate($event, data['data'], 'frequency')" required>
                        <mat-option *ngFor="let frequency of cartFrequencies" [value]="frequency">
                            {{frequency}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="freqSelect.errorState && frequencyControl.hasError('required')">Please choose a frequency</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="p-1">
        <div fxLayout="row" fxLayout.lt-md = "column" fxLayoutAlign="center start">
        <p class=" text-muted " fxShow="false" fxShow.lt-md="true" *ngIf = "!!data['data']['product'].compare_price"><span class = "old-price">{{data['data']['currency']}}
                <span *ngIf = "!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">{{((data['data']['product']['compare_price'] *  quantityControl.value * data['data']['product']['sell_in_conv_rate']) | number: '1.2-4' | replacecomma)  | number : '1.2-2'}}  </span>
                <span *ngIf = "(!!data['data']['product']['sell_in_uof'] === false || (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit') )">{{((data['data']['product'].compare_price  *  quantityControl.value) | number: '1.2-4' | replacecomma) | number : '1.2-2'}}  </span>
              </span> Saved ({{data['data']['product'].savepercentage}}%)</p>                               
            <h3 class="edit-subscription-product-price">
                {{data['data']['currency']}}
                {{(data['data']['product']['retail_price'] * data['data']['cart']['quantity']| number: '1.2-4' | replacecomma) | number: '1.2-2'}}
            </h3>
        <p class=" text-muted pd-l-5" fxShow="false" fxShow.gt-sm = "true" *ngIf = "!!data['data']['product'].compare_price"><span class = "old-price">{{data['data']['currency']}}
                <span *ngIf = "!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] === 'unit'">{{((data['data']['product']['compare_price'] *  quantityControl.value * data['data']['product']['sell_in_conv_rate']) | number: '1.2-4' | replacecomma)  | number : '1.2-2'}}  </span>
                <span *ngIf = "(!!data['data']['product']['sell_in_uof'] === false || (!!data['data']['product']['sell_in_uof'] && data['data']['product']['sell_in_uof'] !== 'unit') )">{{((data['data']['product'].compare_price  *  quantityControl.value) | number: '1.2-4' | replacecomma) | number : '1.2-2'}}  </span>
        </span> Saved ({{data['data']['product'].savepercentage}}%)</p>                               
        </div>
        
        <div class="product-action">
            <button mat-raised-button class="action-btn" [matMenuTriggerFor]="productActionMenu" #productActionMenuTrigger="matMenuTrigger">
        <span class="label">Action</span>
        <mat-icon class="icon">
          {{productActionMenuTrigger.menuOpen ? 'arrow_drop_up' : 'arrow_drop_down'}}
        </mat-icon>
      </button>
            <mat-menu #productActionMenu="matMenu">
                <button mat-menu-item (click)="skipRecurringItemFromProduct(data['data'])" *ngIf="data['data']['cart']['delivery_date'] === selectedDeliveryCalendar['delivery_date'] || (data['data']['cart']['check'] === 'cart' && data['data']['cart']['recurring'] === 1) || (data['data']['cart']['check'] === 'sale' && data['data']['cart']['recurring'] === 1) ">
          <mat-icon class="mat-icon-sm">delete</mat-icon>
          <span>Skip this for 
            <span *ngIf = "data['data']['cart']['check'] !== 'cart'">
                {{data['data']['cart']['delivery_date'] | date: dateFormat}}
            </span>
            <span *ngIf = "data['data']['cart']['check'] === 'cart'">
                {{selectedDeliveryCalendar['delivery_date'] | date: dateFormat}}
            </span>
          </span>
        </button>
                <mat-divider class="divider" *ngIf="data['data']['cart']['delivery_date'] === selectedDeliveryCalendar['delivery_date']"></mat-divider>
                <button mat-menu-item (click)="editRecurringQuantity(data)" *ngIf="data['data']['cart']['delivery_date'] === selectedDeliveryCalendar['delivery_date'] || (data['data']['cart']['check'] === 'cart' && data['data']['cart']['recurring'] === 1) || (data['data']['cart']['check'] === 'sale' && data['data']['cart']['recurring'] === 1) ">
          <mat-icon class="mat-icon-sm">edit</mat-icon>
          <span>Edit Qty for 
            <span *ngIf = "data['data']['cart']['check'] !== 'cart'">
                {{data['data']['cart']['delivery_date'] | date: dateFormat}}
            </span>
            <span  *ngIf = "data['data']['cart']['check'] === 'cart'">
                {{selectedDeliveryCalendar['delivery_date'] | date: dateFormat}}
            </span>
          </span>
        </button>
                <button mat-menu-item (click)="addToThisWeek(data)" *ngIf="data['data']['cart']['delivery_date'] !== selectedDeliveryCalendar['delivery_date'] && (data['data']['cart']['check'] !== 'cart') && (data['data']['cart']['check'] !== 'sale')">
                    <mat-icon class="mat-icon-sm">shopping_cart</mat-icon>
                    <span>Add to this Week</span>
                </button>
                <mat-divider class="divider"></mat-divider>
                <button mat-menu-item (click)="redirectTo('/account/recurring', true)">
                    <mat-icon class="mat-icon-sm">repeat</mat-icon>
                    <span>Manage Recurring Items</span>
                </button>
            </mat-menu>
        </div>
    </div>
</div>
<!-- End -->
<!-- Change Delivery Date Strat -->
<div *ngIf="data['msg'] === 'change delivery date'" class="switch-delivery-date">
    <h1 mat-dialog-title>Switch Date?</h1>
    <div mat-dialog-content class="description">
        <p>You are currently checking your delivery list for {{data['previousDate'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}. Do you now want to switch to {{data['calendar']['delivery_date'] | storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}?</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px" class="action-btn">
        <button mat-button matDialogClose="no" class="no-btn">NO</button>
        <button mat-button matDialogClose="yes" class="yes-btn">YES</button>
    </div>
</div>
<!-- End -->

<!-- Add Special Instruction Start -->
<div fxLayout="column" *ngIf="data['msg'] === 'add special instruction' || data['msg'] === 'edit special instruction' || data['msg'] === 'view special instruction'">
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px">
        <h1 mat-dialog-title class="popup-title">Order Comments</h1>
        <div class="text-end">
            <button mat-mini-fab color="warn" (click)="closeDialog()">
                <i class="material-icons" data-icon="close"></i>
            </button>
        </div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <mat-form-field class="w-100 delivery-details-spl_instruction" appearance="outline">
        <mat-label>Order Comments</mat-label>
        <textarea [readonly] = "!!specialInstruction && !!data['uuid'] && !!orderComments" [(ngModel)]="specialInstruction" matInput [ngStyle.lt-sm]="{'min-height': '50px'}" placeholder="Order Comments">
      </textarea>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="addSpecialInstruction()" class="mt-1" [disabled] = "!!specialInstruction && !!data['uuid'] && !!orderComments">
      {{ !!data['uuid'] ? 'Save' : 'Add' }}
    </button>
</div>
<!-- End -->
<!-- Unconfirmed Order Exist Start -->
<div *ngIf="data['msg'] === 'unconfirmed order exist'">
    <h1 mat-dialog-title>
        <span>Order in pending status</span>
    </h1>
    <div mat-dialog-content>
        <p>
            You already have an order in pending status. You can't create new order until the pending order is approved.
        </p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
        <button mat-button matDialogClose="close" (click)="redirectTo('/account/orders', true)" color="warn" *ngIf="data['yesBtn']">
        Go back to My Orders
      </button>
        <button mat-button matDialogClose="close" color="warn" *ngIf="data['noBtn']">Close</button>
    </div>
</div>
<!-- End -->
<!-- Delivered Order (OR) CutOffTime Exist Start -->
<div *ngIf="data['msg'] === 'delivered order or cutofftime exist'">
    <h1 mat-dialog-title>
        <span>{{data['title']}}</span>
    </h1>
    <div mat-dialog-content>
        <p>{{data['displayMessage']}}</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
        <button mat-button matDialogClose="close" (click)="redirectTo('/account/orders', true)" color="warn" *ngIf="data['yesBtn']">
        Go back to My Orders
      </button>
      <button mat-button matDialogClose="close" color="warn" *ngIf="data['noBtn']">Close</button>
    </div>
</div>
<!-- End -->
 <!-- Order Start date didn't started -->
<div *ngIf="data['msg'] === 'order start date'">
    <h1 mat-dialog-title>
        <span>{{data['title']}}</span>
    </h1>
    <div mat-dialog-content>
        <p>{{data['displayMessage']}}</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
        <button mat-button matDialogClose="close" (click)="redirectTo('/account/orders', true)" color="warn" *ngIf="data['yesBtn']">
        Go back to My Orders
      </button>
      <button mat-button matDialogClose="close" color="warn" *ngIf="data['noBtn']">Close</button>
    </div>
</div>
<!-- Out Of Stock Popup -->
<div class="out-of-stock" *ngIf="data['msg'] === 'out of stock product popup'">
    <h1 mat-dialog-title>
        <span>Sold Out</span>
    </h1>
    <div mat-dialog-content class="description">
        <p>{{data['displayMessage']}}</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" class="action-btn">
      <button mat-button matDialogClose="close" color="warn" class="yes-btn">OK</button>
    </div>
</div>
<!-- End -->
<!-- Add Delivery Instruction Start -->
<div fxLayout="column" *ngIf="data['msg'] === 'add delivery instruction' || data['msg'] === 'update delivery instruction' || data['msg'] === 'view delivery instruction'">
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px">
        <h1 mat-dialog-title class="popup-title">Delivery Instruction</h1>
        <div class="text-end">
            <button mat-mini-fab color="primary" id="closeDialog" (click)="closeDialog()">
                <i class="material-icons" data-icon="close"></i>
            </button>
        </div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <form [formGroup] = "deliveryInstructionForm">
        <div *ngFor="let item of storeDetails['instruction']; let i = index;" >
            <section class="example-section" >
                <div class ="ques">
                    <p>{{item['question']}} <span *ngIf="item.required" style="color: red;">*</span></p>
                </div>
                <!-- <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "option" formArrayName="delivery">
                    <mat-checkbox color = "primary" class="example-margin" *ngFor = "let option of item['options']; let j = index;" (change)="deliveryOptionSelection($event, i, j)" [checked]="option['checked']" 
                     [value] ="option" [formControlName] = "j">{{option['display']}}</mat-checkbox>
                </div> -->
                <div fxLayoutAlign ="center" class="option">
                <div  fxLayoutGap = "15px" class="options" *ngIf = "i === 0" formArrayName="delivery">
                    <mat-checkbox [disabled] = "data['msg'] === 'view delivery instruction'" color = "primary" class="example-margin" *ngFor = "let option of item['options']; let j = index;"  
                    (change)="instructionSelection($event, j)" [checked]="selection.isSelected(j)" [value] ="option" [formControlName] = "j">{{option['display']}}</mat-checkbox>
                </div>
                <div  fxLayoutGap = "15px" class="options" *ngIf = "i === 1" formArrayName="cooler">
                    <mat-checkbox [disabled] = "data['msg'] === 'view delivery instruction'" color = "primary" class="example-margin" *ngFor = "let option of item['options']; let k = index;" 
                    (change)="instructionSelectionSec($event, k)" [checked]="selection2.isSelected(k) " [value] ="option" [formControlName] = "k">{{option['display']}}</mat-checkbox>
                </div>
                <div  fxLayoutGap = "15px" class="options" *ngIf = "i === 2" formArrayName="pets">
                    <mat-checkbox [disabled] = "data['msg'] === 'view delivery instruction'" color = "primary" class="example-margin" *ngFor = "let option of item['options']; let l = index;" 
                    (change)="instructionSelectionThird($event, l)" [checked]="selection3.isSelected(l)"    [value] ="option" [formControlName] = "l">{{option['display']}}</mat-checkbox>
                </div>
                </div>
                <div *ngIf = "deliveryInstructionForm.value['pets'][0] === true && i === 2">
                    <mat-form-field class="w-100 delivery-details-spl_instruction" appearance="outline">
                        <textarea [disabled] = "data['msg'] === 'view delivery instruction'" formControlName = "instruction" placeholder = "Will driver be attacked by German Shephard?" matInput [ngStyle.lt-sm]="{'min-height': '50px'}" >
                        </textarea>
                    </mat-form-field>  
                </div>
            </section>
            <br>
        </div>
           
        <!-- <section class="example-section" >
            <div class ="ques">
                <p>Where will delivery be made?</p>
            </div>
            <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "option" formArrayName="delivery">
                <mat-checkbox color = "primary" class="example-margin" *ngFor = "let option of optionSet1; let i = index;" (change)="$event ? 
                selection.toggle(i) : null" [checked]="selection.isSelected(i)" [value] ="option" [formControlName] = "i">{{option['display']}}</mat-checkbox>
            </div>

          </section>
          <br>
          <section class="example-section" >
              <div class ="ques">
                <p>Will there be a cooler?</p>
              </div>
              <div fxLayoutAlign ="center" fxLayoutGap = "15px" class = "option" formArrayName="cooler">
                <mat-checkbox color = "primary" class="example-margin" *ngFor = "let option of optionSet2; let i = index;" (change)="$event ? 
                selection2.toggle(i) : null" [checked]="selection2.isSelected(i)" [value] ="option" [formControlName] = "i">{{option['display']}}</mat-checkbox>
              </div>
          </section>
          <br>
          <section class="example-section" >
              <div class ="ques">
                    <p>Will there be pet outside?</p>
              </div>
              <div fxLayout = "column"   class = "option">
                  <div fxLayout = "row" fxLayoutAlign ="center" fxLayoutGap = "15px" formArrayName="pets">
                    <mat-checkbox color = "primary" class="example-margin" *ngFor = "let option of optionSet3; let i = index;" (change)="$event ? 
                    selection3.toggle(i) : null" [checked]="selection3.isSelected(i)" [value] ="option" [formControlName] = "i">{{option['display']}}</mat-checkbox>
                  </div>
                  <div *ngIf = "selection3.isSelected(0)">
                        <mat-form-field class="w-100 delivery-details-spl_instruction" appearance="outline">
                            <textarea formControlName = "instruction" placeholder = "Will delivery be attacked by German Shephard?" matInput [ngStyle.lt-sm]="{'min-height': '50px'}" >
                            </textarea>
                        </mat-form-field>  
                  </div>
                
            </div>
          </section> -->
    </form>
   
    <!-- <button *ngIf = "data['msg'] !== 'update delivery instruction'" mat-raised-button color="primary" (click)="addDeliveryInstruction()" class="mt-1" [disabled] = "addingInstruction === true">
        {{ data['msg'] === 'add delivery instruction' ? 'Save' : 'Update' }}
    </button> -->
    <mat-spinner-button fxLayoutAlign = "center" *ngIf = "data['msg'] !== 'view delivery instruction'" [options]="saveButtonOptions" [disabled] = "saveButtonOptions === true" mat-button class = "pd-10" (click)="addDeliveryInstruction()" color = "primary" id="saveBtn">
        {{data['msg'] === 'add delivery instruction' ?  'Save': 'Update'}}</mat-spinner-button>

</div>
<!-- End -->

<!-- Delivery Instruction Info -->
<div *ngIf="data['msg'] === 'delivery instruction info'">
        <h1 mat-dialog-title>
            <span>Delivery Instruction Help</span>
        </h1>
        <div mat-dialog-content>
        <ul>
            <li>Tell us in few words on where exactly do you want us to leave the items.</li>
            <li>If you have a cooler, tell us the location of your cooler.</li>
            <li>If your community has a gate code, let us know what it is.</li>
            <li>Do you want us to ring the doorbell during drop off?</li>

        </ul>
            <!-- <p>
                Tell us in few words on where exactly do you want us to leave the items.
            </p>
            <p>If you have a cooler, tell us the location of your cooler.</p>
            <p>If your community has a gate code, let us know what it is.</p>
            <p>Do you want us to ring the doorbell during drop off?</p> -->
        </div>
        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center">
            <button mat-button matDialogClose="close" >
                Close
            </button>
        </div>
    </div>
    <!-- End -->

<!-- vacation Date present so cannot save order -->
<div class="out-of-stock" *ngIf="data['msg'] === 'vacation date present'">
    <div mat-dialog-content class="description">
        <p>{{data['displayMessage']}}</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" class="action-btn">
      <button mat-button matDialogClose="close" color="warn" class="yes-btn">OK</button>
    </div>
</div>
<!-- End -->

<!-- Delivery fee alert -->

<h1 mat-dialog-title *ngIf="data['msg'] === 'delivery fee alert'">
    <span >Info</span>
</h1>
<div mat-dialog-content *ngIf="data['msg'] === 'delivery fee alert'">
    <p>{{data['display']}} </p>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'delivery fee alert'" fxLayoutAlign ="end" class = "pd-16"> 
    <button   mat-button *ngIf = "data['showProceedBtn'] === true" matDialogClose="proceed" color="warn">It's ok, save my order</button>
    <button mat-button cdkFocusRegionstart matDialogClose="close" class = "color-grn" >Yes</button>
</div>
<!-- end -->

<!-- Minimum Order alert -->

<h1 mat-dialog-title *ngIf="data['msg'] === 'minimum order alert'">
    <span >Info</span>
</h1>
<div mat-dialog-content *ngIf="data['msg'] === 'minimum order alert'">
    <p>{{data['display']}} </p>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'minimum order alert'" fxLayoutAlign ="end" class = "pd-16"> 
    <button   mat-button *ngIf = "data['showProceedBtn'] === true" matDialogClose="proceedsaveorder" color="warn">It's ok, save my order</button>
    <button mat-button cdkFocusRegionstart matDialogClose="close" class = "color-grn" >Cancel</button>
</div>
<!-- end -->

<!-- Sign up delivery address alert -->

<h1 mat-dialog-title *ngIf="data['msg'] === 'delivery address alert'">
    <span >{{data['title']}}</span>
</h1>
<div mat-dialog-content *ngIf="data['msg'] === 'delivery address alert'">
    <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_waitlist_success_message']">
        <p [innerHTML]="data.display" ></p>
    </ng-container>
    <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_waitlist_success_message']">
        <p>{{data['display']}} </p>
    </ng-container>
</div>
<div mat-dialog-actions *ngIf="data['msg'] === 'delivery address alert'" fxLayoutAlign ="end" class = "pd-16"> 
    <button mat-stroked-button color="accent" *ngIf = "data['showProceedBtn'] === true" matDialogClose="{{data['proceed']}}" color="warn">{{data['proceed']}}</button>
    <button mat-stroked-button color="accent" *ngIf = "data['showCloseBtn'] === true" cdkFocusRegionstart matDialogClose="close" class = "color-grn" >{{data['close']}}</button>
</div>
<!-- end -->

<!-- Sign up Waiting List popup form -->

<div fxLayout="column" *ngIf="data['msg'] === 'waiting list form'" class="popup-content">
    <div class="text-end">
        <button mat-mini-fab color="warn" matDialogClose="close">
            <i class="material-icons" data-icon="close"></i>
        </button>
    </div>
    <div class="popup-content-below">
    <div fxLayout="row wrap" fxLayoutGap="5px">
        <h1 mat-dialog-title class="popup-title">Expand Service to Your Address</h1>
        <span>Thank you for your interest! It looks like your address isn't in our standard service area just yet. To help us serve you better, please fill out our service request form. This way, a team member can get in touch to explore possible options for you. </span>
    </div>
    <mat-divider class="divider"></mat-divider>
    <form [formGroup] = "waitingListForm">
        <div fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
              <mat-form-field appearance="outline"  class="w-100">
                <mat-label>First Name</mat-label>
                <input matInput placeholder="First name" formControlName="first_name" id="waiting_first_name" required>
                <mat-error *ngIf="waitingListForm.controls.first_name.errors?.required">First Name is required</mat-error>
                <mat-error *ngIf="waitingListForm.controls.first_name.hasError('maxlength')">First Name characters should be within 35</mat-error>
                <mat-error *ngIf="waitingListForm.controls.first_name.hasError('validation')">
                    {{waitingListForm.controls.first_name.errors.message}}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
              <mat-form-field appearance="outline"  class="w-100">
                <mat-label>Last Name</mat-label>
                <input matInput placeholder="Last name" formControlName="last_name" id="waiting_last_name" required>
                <mat-error *ngIf="waitingListForm.controls.last_name.errors?.required">Last Name is required</mat-error>
                <mat-error *ngIf="waitingListForm.controls.last_name.hasError('maxlength')">Last Name characters should be within 35</mat-error>
                <mat-error *ngIf="waitingListForm.controls.last_name.hasError('validation')">
                    {{waitingListForm.controls.last_name.errors.message}}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                <mat-form-field appearance="outline"  class="w-100">
                  <mat-label>Email</mat-label>
                  <input type="email" matInput placeholder="Email" formControlName="email_id" id="waiting_email_id" required>
                  <mat-error *ngIf="waitingListForm.controls.email_id.errors?.required">Email is required</mat-error>
                  <mat-error *ngIf="waitingListForm.controls.email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                  <mat-error *ngIf="waitingListForm.controls.email_id.hasError('validation')">
                      <span [innerHTML]="waitingListForm.controls.email_id.errors.message | sanitizeHtml"></span>
                  </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                <mat-form-field appearance="outline"  class="w-100">
                  <mat-label>Verify Email</mat-label>
                  <input type="email" matInput placeholder="Email" formControlName="verify_email_id" id="waiting_verify_email_id" required>
                  <mat-error *ngIf="waitingListForm.controls.verify_email_id.errors?.required">Verify Email is required</mat-error>
                  <mat-error *ngIf="waitingListForm.controls.verify_email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                  <mat-error *ngIf="!!waitingListForm.controls.verify_email_id.hasError('emailMismatch') && !waitingListForm.controls.verify_email_id.hasError('invalidEmail')">Email address mismatch! </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
              <mat-form-field appearance="outline"  class="w-100">
                <mat-label>Phone Number</mat-label>
                <input type="tel" matInput placeholder="Phone Number" formControlName="phone_number" id="waiting_phone_number" required [value]="waitingListForm.get('phone_number').value | phone: 'US'">
                <mat-error *ngIf="waitingListForm.controls.phone_number.errors?.required">Phone Number is required</mat-error>
                <mat-error *ngIf="waitingListForm.controls.phone_number.hasError('minlength')">Phone Number isn't long enough, minimum of 10 characters</mat-error>
                <mat-error *ngIf="waitingListForm.controls.phone_number.hasError('validation')">
                    <span [innerHTML]="waitingListForm.controls.phone_number.errors.message | sanitizeHtml"></span>
                </mat-error>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="p-1" fxFlex="100%">
                <button mat-raised-button color="primary" id="waiting_request" (click)="onWaitingListRequest()">Submit Request</button>
            </div>
            <div mat-dialog-actions *ngIf="data['msg'] === 'waiting list form'" fxLayoutAlign ="end" class = "pd-16"
            fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100%"> 
                <button mat-stroked-button color="accent" id="waiting_proceed" *ngIf = "data['showProceedBtn'] === true" matDialogClose="close" color="warn">{{data['proceed']}}</button>
                <!-- <button mat-button (click)="onWaitingListRequest()">Added Request</button> -->
                <button mat-stroked-button color="accent" id="waiting_close" *ngIf = "data['showCloseBtn'] === true" cdkFocusRegionstart matDialogClose="close" class = "color-grn" >{{data['close']}}</button>
            </div>
        </div>
    </form>
</div>
</div>
<!-- end -->

<!-- Tipping Feature popup -->
<div fxLayout="column" *ngIf="data['msg'] === 'add tips dialog'" class="tips-popup">
    <div fxLayout="row" fxLayoutAlign="space-between" class="dialog-header">
        <div><span class="tipsTitle">Add Tips</span>
            <div class="tipMessage">
                <p>Show your Support for the Team at {{data['siteName']}}!</p>
            </div>
        </div>
        <div>
            <button mat-mini-fab color="warn" matDialogClose="close" (click)="closeDialog()">
                <i class="material-icons" data-icon="close"></i>
            </button>
        </div>
    </div>
    <mat-divider class="divider-1"></mat-divider>
    <div class="tipContainer">        
        <p class="tipThanksMsg mt-1" *ngIf="tipsSettings['thanksMsg'] || tipsSettings['sale_order']">Thank you, we appreciate it!</p>
        <div class="tipPercentageContainer mt-1">
            <div class="perBtn mt-1">
                <button *ngFor="let option of tipsOption | keyvalue" 
                    mat-button 
                    class="tipOption" 
                    [ngClass]="{'activeTip': selectedTip === option.value, 'btn-clr': selectedTip !== option.value}"
                    (click)="selectTip(option.value)">
                    {{ option.value }}%
                </button>          
                <button mat-button class="tipOption" 
                    [ngClass]="{'activeTip': selectedTip === 'None', 'btn-clr': selectedTip !== 'None'}"
                    (click)="selectTip('None')">None</button>
            </div>
            <div class="customTipBtn">
                <mat-form-field appearance="fill" class="custom-tip-input mt-1">
                    <mat-label>Custom tip</mat-label>
                    <input matInput type="number" min="0" placeholder="Enter custom tip amount" [(ngModel)]="customerRecurringTip" (ngModelChange)="onCustomTipChange()">
                </mat-form-field>
                <button mat-button class="tipUpdatebtn" (click)="updateTip()">Update tip</button>
            </div>
        </div>
        <div class="tipWeek mt-1">
            <span *ngIf="!!this.featureTags && !this.featureTags['sf_tipping_feature_2']">
                <input type="checkbox" name="tip" [(ngModel)]="isRecurringTip"> 
                Tip only this order (Uncheck to make this a recurring tip. <a target="_blank" routerLink="/account/addresses">Edit or Disable Recurring Tip</a>)
            </span>
            <span *ngIf="!!this.featureTags && this.featureTags['sf_tipping_feature_2']">
                <input type="checkbox" name="tip" [(ngModel)]="isRecurringTip"> 
                Tip only this order (Uncheck to make this a recurring tip.<a *ngIf="this.tipsSettings['is_recurring_tips_enabled']" target="_blank" routerLink="/account/addresses"> Edit or Disable Recurring Tip</a>)
            </span>
        </div>
    </div>
</div>
<!-- end -->

<!-- Tipping Feature popup -->
<div fxLayout="column" *ngIf="data['msg'] === 'add recurring tips dialog'" class="tips-popup">
    <div fxLayout="row" fxLayoutAlign="space-between" class="dialog-header">
        <div><span class="tipsTitle">Add Tips</span>
            <div class="tipMessage">
                <p>Show your Support for the Team at {{data['siteName']}}!</p>
            </div>
        </div>
        <div>
            <button mat-mini-fab color="warn" matDialogClose="close" (click)="closeDialog()">
                <i class="material-icons" data-icon="close"></i>
            </button>
        </div>
    </div>
    <mat-divider class="divider-1"></mat-divider>
    <div class="tipContainer">        
        <p class="tipThanksMsg mt-1" *ngIf="tipsSettings['thanksMsg']">Thank you, we appreciate it!</p>
        <div class="tipPercentageContainer mt-1">
            <div class="perBtn mt-1">
                <button *ngFor="let option of tipsOption | keyvalue" 
                    mat-button 
                    class="tipOption" 
                    [ngClass]="{'activeTip': selectedTip === option.value, 'btn-clr': selectedTip !== option.value}"
                    (click)="selectTip(option.value)">
                    {{ option.value }}%
                </button>          
                <button mat-button class="tipOption" 
                    [ngClass]="{'activeTip': selectedTip === 'None', 'btn-clr': selectedTip !== 'None'}"
                    (click)="selectTip('None')">None</button>
            </div>
            <div class="customTipBtn">
                <mat-form-field appearance="fill" class="custom-tip-input mt-1">
                    <mat-label>Custom tip</mat-label>
                    <input matInput type="number" min="0" placeholder="Enter custom tip amount" [(ngModel)]="customerRecurringTip" (ngModelChange)="onCustomTipChange()">
                </mat-form-field>
                <button mat-button class="tipUpdatebtn" (click)="updateTips()">Update tip</button>
            </div>
        </div>
        <div class="tipWeek mt-1">
            <span *ngIf="!!this.featureTags && !this.featureTags['sf_tipping_feature_2']">
                <input type="checkbox" name="tip" [(ngModel)]="isRecurringTip"> 
                Tip only this order (Uncheck to make this a recurring tip. <a target="_blank" routerLink="/account/addresses">Edit or Disable Recurring Tip</a>)
            </span>
            <span *ngIf="!!this.featureTags && this.featureTags['sf_tipping_feature_2']">
                <input type="checkbox" name="tip" [(ngModel)]="isRecurringTip"> 
                Tip only this order (Uncheck to make this a recurring tip.<a *ngIf="this.tipsSettings['is_recurring_tips_enabled']" target="_blank" routerLink="/account/addresses"> Edit or Disable Recurring Tip</a>)
            </span>
        </div>
    </div>
</div>
<!-- end -->
 
<!-- Save Order alert for unsaved cart products -->
<div class="save-order-alert" *ngIf="data['msg'] === 'save order alert'">
    <h4 class="save-order-alert-heading">Don’t Forget to Save Your Order!</h4>
    <div mat-dialog-content class="save-order-alert-text">
        <p>You have items in your cart. If you close or navigate away from this page now, your delivery won’t be scheduled, and you may lose your items.</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" class="action-btn save-btn-alert">
      <button mat-raised-button (click)="saveLater()">Save Later</button>
      <button mat-raised-button class="save" color='primary' (click)="saveOrderNow()">Save Order</button>
    </div>
</div>
<!-- End -->

<!-- Open Orders Detected on Vacation Dates -->
<div *ngIf="data['msg'] === 'sale order delete alert'">
    <h1 mat-dialog-title>
        <span>Open Orders Detected on Vacation Dates</span>
    </h1>
    <div mat-dialog-content>
        <p>You have open orders scheduled for the following date(s): {{data['formattedDates']}}. Do you want to proceed with deleting them?</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
        <button mat-raised-button (click)="deleteSaleOrder()">Yes</button>
        <button mat-button matDialogClose="close" color='primary'>No</button>
    </div>
</div>
<!-- End -->

<div *ngIf="data['msg'] === 'cancel membership'">
    <h1 mat-dialog-title>
        <span>Disabling Auto-Renewal</span>
    </h1>
    <div mat-dialog-content>
        <p>Are you sure you want to disable auto-renewal of your membership?</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
        <button mat-raised-button (click)="confirm()">Yes</button>
        <button mat-button matDialogClose="close" color='primary'>No</button>
    </div>
</div>

<!-- first order message -->
<div class="out-of-stock" *ngIf="data['msg'] === 'first order message'">
    <div mat-dialog-content class="description">
        <p [innerHTML]="data['displayMessage']| sanitizeHtml"></p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end" class="action-btn">
      <button mat-button matDialogClose="close" color="warn" class="yes-btn">OK</button>
    </div>
</div>
<!-- End -->
</ng-container>